/* eslint-disable */
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryOptions, UseMutationOptions, QueryKey } from '@tanstack/react-query';

import { courseFetcher } from '../utils/Fetcher';
import type { RequestOptions } from '../utils/Fetcher';
const fetcher = courseFetcher;

export type Maybe<T> = T | null;

export type OneOf<T> = T extends unknown[]
  ? T[number]
  : T extends readonly unknown[]
  ? T[number]
  : T;

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]-?: Exclude<T[K], undefined>;
};

export type Values<T extends Record<string, unknown>> = T extends Record<string, infer U>
  ? U
  : T extends { [key: string]: infer U }
  ? U
  : never;

export const enum ResponseStatus {
  OK = 'OK',
  SERVER_ERROR = 'SERVER_ERROR',
  DUPLICATE = 'DUPLICATE',
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  BAD_PARAMETER = 'BAD_PARAMETER',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
}

export type Success<T = unknown> = {
  statusCode: ResponseStatus.OK;
  message: '';
  data: T;
  errorCode: string;
};

export type Error = {
  statusCode: Omit<keyof typeof ResponseStatus, 'OK'>;
  message: string;
  data: Maybe<''>;
  errorCode: string;
};

/**
 * @typeParam T - Response data type
 */
export type ApiResponse<T = unknown> = Success<T>;


export const API_ENDPOINT = {
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM: '/client/api/v1/course-contract-histories/inflearn-marketing-confirm',
  CLIENT_V1_COUPONS_INSTRUCTOR: '/client/api/v1/coupons/instructor',
  CLIENT_V1_INSTRUCTORS_COUPON_AVAILABLE_COURSES: '/client/api/v1/instructors/coupon-available-courses',
  CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM: '/client/api/v1/course-contracts/inflearn-marketing-contents-term',
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED: '/client/api/v1/course-contract-histories/inflearn-marketing-confirm-required'
};


export function useClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation<TContext>({
    url,
    options,
    requestOptions,
  }: {
    url: string;
    options?: UseMutationOptions<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse, unknown, ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables, TContext>;
    requestOptions?: RequestOptions;
  }) {
    const result = useMutation<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse, unknown, ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables, TContext>({
      mutationFn: (variables: ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables) => fetcher.post(url, variables, requestOptions),
      ...options,
    })

    return { ...result, data: result.data?.data };
  }

export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables = InflearnMarketingConfirmRequest;


export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse = EmptyOkResponse;


export function useClientApiV1CouponsInstructorCreateMutation<TContext>({
    url,
    options,
    requestOptions,
  }: {
    url: string;
    options?: UseMutationOptions<ClientApiV1CouponsInstructorCreateResponse, unknown, ClientApiV1CouponsInstructorCreateVariables, TContext>;
    requestOptions?: RequestOptions;
  }) {
    const result = useMutation<ClientApiV1CouponsInstructorCreateResponse, unknown, ClientApiV1CouponsInstructorCreateVariables, TContext>({
      mutationFn: (variables: ClientApiV1CouponsInstructorCreateVariables) => fetcher.post(url, variables, requestOptions),
      ...options,
    })

    return { ...result, data: result.data?.data };
  }

export type ClientApiV1CouponsInstructorCreateVariables = CreateInstructorCouponRequest;


export type ClientApiV1CouponsInstructorCreateResponse = ApiResponseCreateInstructorCouponResponse;



export const fetchClientApiV1InstructorsCouponAvailableCourses = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1InstructorsCouponAvailableCoursesResponse>(url, requestOptions);

export interface ClientApiV1InstructorsCouponAvailableCoursesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1InstructorsCouponAvailableCoursesResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1InstructorsCouponAvailableCoursesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1InstructorsCouponAvailableCoursesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1InstructorsCouponAvailableCourses(url, requestOptions),
  ...options
});

export function useClientApiV1InstructorsCouponAvailableCoursesQuery(params: ClientApiV1InstructorsCouponAvailableCoursesQueryParams) {
  const result = useQuery<ClientApiV1InstructorsCouponAvailableCoursesResponse, unknown>(getClientApiV1InstructorsCouponAvailableCoursesQueryOptions(params));

  return { ...result, data: result.data?.data };
}

export type ClientApiV1InstructorsCouponAvailableCoursesResponse = ApiResponseFindCouponAvailableCourseForInstructorResponse;



export const fetchClientApiV1CourseContractsInflearnMarketingContentsTerm = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse>(url, requestOptions);

export interface ClientApiV1CourseContractsInflearnMarketingContentsTermQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseContractsInflearnMarketingContentsTermQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseContractsInflearnMarketingContentsTermQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseContractsInflearnMarketingContentsTerm(url, requestOptions),
  ...options
});

export function useClientApiV1CourseContractsInflearnMarketingContentsTermQuery(params: ClientApiV1CourseContractsInflearnMarketingContentsTermQueryParams) {
  const result = useQuery<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse, unknown>(getClientApiV1CourseContractsInflearnMarketingContentsTermQueryOptions(params));

  return { ...result, data: result.data?.data };
}

/** 인프랩 마케팅 약관을 조회한다 */
export type ClientApiV1CourseContractsInflearnMarketingContentsTermQueryString = Partial<{
  isNew: boolean;
}>;


export type ClientApiV1CourseContractsInflearnMarketingContentsTermResponse = ApiResponseGetInflearnMarketingContentTermResponse;



export const fetchClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequired = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse>(url, requestOptions);

export interface ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequired(url, requestOptions),
  ...options
});

export function useClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQuery(params: ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQueryParams) {
  const result = useQuery<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse, unknown>(getClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQueryOptions(params));

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse = ApiResponseFindInflearnMarketingConfirmRequiredCoursesResponse;


export interface BookRequest {
  thumbnailUrl: string;
  url: string;
  authors: string[];
  translators: string[];
  publisher: string;
  isbn: string
}


export interface CourseRequest {
  id: number
}


export interface LinkRequest {
  thumbnailUrl: string;
  url: string;
  iconUrl: string
}


export interface RoadmapItemRequest {
  title: string;
  description: string;
  type: ("COURSE" | "BOOK" | "LINK");
  course?: CourseRequest;
  book?: BookRequest;
  link?: LinkRequest
}


export interface PublishRoadmapResponse {
  id: number
}


export interface SaveDraftRoadmapResponse {
  id: number
}


export interface MissionAttachmentRequest {
  type: ("LINK" | "IMAGE" | "FILE");
  value: string
}


export interface EmptyOkResponse {
  message: string;
  data?: string
  | null;
  errorCode?: string
  | null;
  statusCode: string
}


export interface EntryEvent {
  code: string;
  entryAt: string
}


export interface BankAccount {
  code: ("NH" | "KB" | "WOORI" | "SHINHAN" | "IBK" | "HANA" | "GYEONGNAM" | "DAEGU" | "BUSAN" | "SUHYUP" | "POST" | "KDB" | "SC" | "CITI" | "DGB" | "GWANGJU" | "JEJU" | "JEONBUK" | "SAE_MAUL" | "SHINHYEOP" | "K_BANK" | "KAKAO_BANK");
  account: string;
  accountHolder: string
}


export interface UpdateCourseInstructorSettingsRequestDto {
  userId: number;
  isQuestionEmailAllowed: boolean;
  type: ("MAIN" | "SUB")
}


export interface SyncSurveyChoice {
  id?: number
  | null;
  content: string
}


export interface SyncSurveyQuestion {
  id?: number
  | null;
  content: string;
  isRequired: boolean;
  isDefaultQuestion: boolean;
  type: ("SUBJECTIVE" | "OBJECTIVE" | "MULTIPLE_OBJECTIVE" | "FILE");
  choices: SyncSurveyChoice[]
}


export interface UpdateCourseFaqRequestDto {
  id?: number
  | null;
  body: string;
  title: string
}


export interface ConfirmCourseCertificateResponse {
  now: string;
  nowUTC: string
}


export interface Benefit {
  type: string;
  iconType?: string
  | null;
  title?: string
  | null
}


export interface GetVouchersResponse {
  id: number;
  courseId: number;
  userId: number;
  unitId?: number
  | null;
  cartId?: number
  | null;
  orderItemId?: number
  | null;
  groupId?: number
  | null;
  type: string;
  progress: string;
  completeCount: number;
  /**
   * 이전에 사용하던 필드로 하위 호환성을 위해 추가(limitedAt을 전달), 블랙팬서 등 사용하지 않게 되면 제거
   */
  limitedDate?: string
  | null;
  createdAt: string;
  startedAt?: string
  | null;
  accessedAt?: string
  | null;
  completedAt?: string
  | null;
  certificatedAt?: string
  | null;
  deletedAt?: string
  | null;
  isArchive: boolean;
  groupCode?: string
  | null;
  hasDownload: boolean;
  hasVideoDownload: boolean;
  completeRuntime: number;
  memo?: string
  | null;
  confirmedAt?: string
  | null;
  certificateConfirmedAt?: string
  | null;
  limitedAt?: string
  | null;
  isValid: boolean
}


export interface ChoiceItem {
  id: number;
  content: string
}


export interface CommissionRate {
  agreed: number;
  disagreed: number
}


export interface ExpireSubscriptionVoucherResponse {
  expiredCount: number
}


export interface FeaturedChallenge {
  courseId: number;
  exposureStartedAtUTC?: string
  | null;
  exposureEndedAtUTC?: string
  | null
}


export interface UpdateRoadmapResponse {
  isNewPublish: boolean
}


export interface CreateRoadmapResponse {
  id: number
}


export interface CreateOrderBuyerDto {
  name: string;
  email: string;
  phoneNumber: string;
  countryCode: string
}


export interface CreateOrderCartDto {
  cartId: number;
  courseId: number;
  title: string;
  duration?: number
  | null;
  regularPrice: number;
  paymentPrice: number;
  discountId?: number
  | null;
  discountType?: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON")
}


export interface DomesticPayMetadataDto {
  payPgType: ("NAVERPAY" | "TOSS" | "TOSS_PAY");
  payMethod: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "PAYCO" | "TOSSPAY" | "TOSS_PAY_MONEY" | "APPLEPAY" | "VIRTUAL_ACCOUNT" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "BANK_TRANSFER" | "LINKPAY" | "UNKNOWN" | "NONE")
}


export interface Buyer {
  email: string;
  phoneNumber: string;
  name: string;
  countryCode: string
}


export interface CreateOrderResponse {
  id: number;
  merchantUid: string;
  title: string;
  buyer: Buyer;
  returnUrl: string
}


export interface CreatePaymentRequestDto {
  cardId: number;
  cardMessage: string;
  payer?: Payer
}


export interface DomesticPayMetadata {
  payPgType: string;
  payMethod: string
}


export interface Payer {
  name?: string
  | null;
  phone?: string
  | null
}


export interface PaymentRequestCartDto {
  cartId: number;
  title: string;
  regularPrice: number;
  paymentPrice: number;
  discountId?: number
  | null;
  discountType: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON")
}


export interface CreateGlobalOrderCartDto {
  cartId: number;
  courseId: number;
  title: string;
  regularPrice: number;
  paymentPrice: number;
  discountId?: number
  | null;
  discountType?: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON")
}


export interface GlobalPayMetadataDto {
  payPgType: ("PORTONE" | "TOSS");
  payMethod: ("NONE" | "PAYPAL")
}


export interface CreateGlobalOrderResponse {
  id: number;
  merchantUid: string;
  title: string;
  buyer: Buyer;
  paymentPrice: number;
  currency: ("KRW" | "USD" | "VND" | "JPY");
  payMetadata: GlobalPayMetadataDto;
  signatureHash: string;
  token?: string
  | null;
  returnUrl: string
}


export interface IssueChallengeEventCouponResponse {
  courseIds: number[]
}


export interface StopMessageResponse {
  code: string;
  stopMessage: string
}


export interface CreateSectionResponse {
  id: number
}


export interface SaveRoadmapCourseDto {
  id: number;
  description: string
}


export interface SaveRoadmapHistoryResponse {
  id: number
}


export interface RestoreRoadmapHistoryResponse {
  id: number
}


export interface UploadRoadmapContentVideoResponse {
  url: string
}


export interface UploadRoadmapContentImageResponse {
  url: string
}


export interface CreateRoadmapContentTemplateResponse {
  id: number
}


export interface QuizQuestionChoiceAnswerResponse {
  isAnswer: boolean;
  progress: number;
  explanation?: string
  | null
}


export interface WebhookData {
  paymentKey: string;
  status: ("READY" | "IN_PROGRESS" | "WAITING_FOR_DEPOSIT" | "DONE" | "CANCELED" | "PARTIAL_CANCELED" | "ABORTED" | "EXPIRED")
}


export interface UploadRoadmapThumbnailResponse {
  id: number;
  url: string
}


export interface CreateMissionLectureResponse {
  id: number
}


export interface SignupMarketingPartnerResponse {
  id: number;
  commissionRate: CommissionRate
}


export interface CreateMarketingPartnerLinkResponse {
  link: string
}


export interface CreateLiveSessionUnitResponse {
  unitId: number
}


export interface GetLiveSessionUnitTokenResponse {
  token: string;
  role: ("ADMIN" | "INSTRUCTOR" | "STUDENT" | "STUDENT_VIEWER" | "RECORDER")
}


export interface ExtendLiveSessionUnitResponse {
  closedAt?: string
  | null;
  closedAtUTC: string
}


export interface CreateLectureResponse {
  id: number
}


export interface LectureItem {
  fileId: number;
  title: string
}


export interface CheckKoreanImageHttpResponse {
  hangulTexts?: string
  | null;
  hasHangul: boolean
}


export interface CreateCourseResponse {
  id: number
}


export interface UploadCourseSurveyFileResponse {
  name: string;
  url: string
}


export interface SurveyChoiceRequest {
  id: number
}


export interface SurveyQuestionRequest {
  id: number;
  answer?: string
  | null;
  choices: SurveyChoiceRequest[]
}


export interface CourseGift {
  cardId: number;
  cardMessage: string;
  receiveType: ("PHONE" | "LINK");
  receiver: CreateCourseGiftReceiver
}


export interface CreateCourseGiftOrderCourseInfo {
  id: number;
  title: string;
  regularPrice: number;
  paymentPrice: number;
  discountId?: number
  | null;
  discountType: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON")
}


export interface CreateCourseGiftReceiver {
  name: string;
  phone?: string
  | null
}


export interface CreateCourseGiftOrderResponse {
  id: number;
  merchantUid: string;
  title: string;
  buyer: Buyer;
  returnUrl: string
}


export interface CourseVideoMetadata {
  isValidSize: boolean;
  isValidType: boolean
}


export interface CreateVodUploadUrlResponse {
  uploadUrl: string;
  id: number;
  metadata: VodFileMetadata
}


export interface VodFileMetadata {
  name: string;
  updatedAt: string;
  type: string
}


export interface CourseCoverMetadata {
  isValidSize: boolean;
  isValidType: boolean;
  isValidKorean: boolean;
  isValidDimension: boolean
}


export interface UploadCourseCoverThumbnailMetadata {
  name: string;
  type: string;
  updatedAt: string
}


export interface UploadCourseCoverThumbnailResponse {
  url: string;
  id: number;
  metadata: UploadCourseCoverThumbnailMetadata
}


export interface UploadCourseCoverImageResponse {
  url: string;
  fileId: number
}


export interface RetryCourseCoverAiGenerationResponse {
  retryGenerationHistoryId: number
}


export interface UploadCourseCoverAiGenerationCompositeMetadata {
  name: string;
  type: string;
  updatedAt: string
}


export interface UploadCourseCoverAiGenerationCompositeResponse {
  id: number;
  url: string;
  metadata: UploadCourseCoverAiGenerationCompositeMetadata
}


export interface ContractAgreementRequest {
  contractType: ("PLATFORM" | "INFLUENCER" | "OFFLINE" | "E" | "EXCLUSIVE" | "NONEXCLUSIVE");
  b2bSubscriptionAgreement: boolean;
  inflearnMarketingAgreement: boolean
}


export interface EarlyBirdSaleRequest {
  earlyBirdSaleTerm: ("AGREE" | "DISAGREE" | "DELEGATE");
  salePeriodInWeeks?: number
  | null;
  saleRate?: number
  | null
}


export interface InflearnMarketingConfirmDto {
  courseId: number;
  isAgreed: boolean
}


export interface InflearnMarketingConfirmRequest {
  items: InflearnMarketingConfirmDto[]
}


export interface UploadCourseContentVideoResponse {
  url: string
}


export interface UploadCourseContentImageResponse {
  url: string
}


export interface CreateCourseContentTemplateResponse {
  id: number
}


export interface CreateCourseContentHistoryResponse {
  id: number
}


export interface RestoreCourseContentHistoryResponse {
  id: number
}


export interface CreateManualCourseContentHistoryResponse {
  id: number
}


export interface GenerateCourseContentResponse {
  generationHistoryId: number
}


export interface IssueCouponResponse {
  id: number;
  couponId: number;
  title: string;
  targetType: ("ALL" | "SELECTED" | "CATEGORY" | "SKILL" | "ROADMAP" | "COMMON_TAG");
  targetIds: number[]
}


export interface CreateInstructorCouponRequest {
  courseId: number;
  discountValue: number;
  endedAt: string;
  limitCount: number
}


export interface ApiResponseCreateInstructorCouponResponse {
  statusCode: ("OK" | "CREATED" | "BAD_REQUEST" | "NOT_FOUND" | "INTERNAL_SERVER_ERROR" | "FORBIDDEN" | "CONFLICT" | "UNAUTHORIZED" | "PAYLOAD_TOO_LARGE" | "TOO_MANY_REQUESTS");
  message: string;
  errorCode?: string
  | null;
  data: CreateInstructorCouponResponse
}


export interface CreateInstructorCouponResponse {
  code: string
}


export interface UpdateCurrentTimeResponse {
  now: number;
  isCompleted: boolean;
  prevProgress: string;
  progress: string;
  isFirstCompleted: boolean
}


export interface CommonTagResponse {
  id: number;
  title: string;
  subTitle: string;
  slug: string;
  isCuration: boolean
}


export interface AddCartDto {
  courseId: number;
  cartId: number
}


export interface AddCartsResponse {
  items: AddCartDto[]
}


export interface CreateVoucherItem {
  type: ("LEGACY" | "IS_ADMIN" | "BY_ADMIN" | "IS_INSTRUCTOR" | "BY_INSTRUCTOR" | "FREE" | "ORDER" | "CODE" | "GROUP_ORDER" | "GROUP_SUBSCRIPTION" | "COURSE_GIFT");
  userId: number;
  courseId: number;
  limitedAt?: string
  | null;
  orderItemId?: number
  | null;
  cartId?: number
  | null;
  groupId?: number
  | null;
  groupCode?: string
  | null
}


export interface VerifySignUpDiscountResponse {
  isSignUpDiscountDeleted: boolean
}


export interface UploadPromotionCardImageResponse {
  id: number;
  url: string
}


export interface Enrolment {
  userId: number;
  courseId: number;
  limitedAt?: string
  | null;
  b2bCoursePrice?: number
  | null;
  b2bCourseUsdPrice?: number
  | null
}


export interface BatchCreateGroupVoucherResponse {
  voucherId: number;
  userId: number;
  courseId: number;
  regularPrice: number;
  orderItemId: number;
  limitedAt?: string
  | null;
  createdAt: string
}


export interface PromptItem {
  id?: number
  | null;
  prompt: string;
  model: string
}


export interface DetectCourseContentLanguageResponse {
  languageCode: string
}


export interface ConfirmCourseConfirmationResponse {
  confirmedAt: string;
  confirmedAtUTC: string
}


export interface UnitCurrentTime {
  id: number;
  lastCurrentTime: number
}


export interface BulkUpdateCurrentTimeResponse {
  items: CurrentTimeResponse[]
}


export interface CurrentTimeResponse {
  unitId: number;
  now: number;
  isCompleted: boolean;
  prevProgress: string;
  progress: string;
  isFirstCompleted: boolean
}


export interface PartnerSkillTagRecommendationItem {
  id: number;
  title: string;
  slug: string
}


export interface PartnerSkillTagRecommendationResponse {
  items: PartnerSkillTagRecommendationItem[]
}


export interface PartnerCourseRecommendationCategory {
  title: string;
  parentTitle: string
}


export interface PartnerCourseRecommendationItem {
  url: string;
  title: string;
  thumbnailUrl: string;
  description: string;
  reviewCount: number;
  reviewAverage: number;
  abilities: string[];
  targets: string[];
  instructorName: string;
  level: string;
  categories: PartnerCourseRecommendationCategory[];
  skills: string[]
}


export interface PartnerCourseRecommendationResponse {
  items: PartnerCourseRecommendationItem[]
}


export interface FindParentCategoryResponse {
  categories: ParentCategoryDto[]
}


export interface ParentCategoryDto {
  id: number;
  slug: string;
  title: string;
  originalTitle: string;
  icon: string
}


export interface ChildCategoryDto {
  id: number;
  slug: string;
  title: string;
  originalTitle: string
}


export interface FindChildCategoryResponse {
  subCategories: ChildCategoryDto[]
}


export interface GetAllLevelsResponse {
  levels: LevelSummaryDto[]
}


export interface LevelSummaryDto {
  title?: string
  | null;
  slug: string;
  description?: string
  | null;
  code: string
}


export interface MyVoucherChallengeCourseDto {
  id: number;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface MyVoucherCourseDto {
  id: number;
  slug: string;
  title: string;
  lectureCount: number;
  thumbnailUrl: string;
  instructorId: number;
  instructorName: string;
  offlineCourse?: MyVoucherOfflineCourseDto;
  challengeCourse?: MyVoucherChallengeCourseDto;
  childCategories: string[]
}


export interface MyVoucherDto {
  id: number;
  userId: number;
  unitId: number;
  progress: string;
  completeCount: number;
  limitedAt?: string
  | null;
  isArchived: boolean;
  hasCertificate: boolean;
  type: ("LEGACY" | "IS_ADMIN" | "BY_ADMIN" | "IS_INSTRUCTOR" | "BY_INSTRUCTOR" | "FREE" | "ORDER" | "CODE" | "GROUP_ORDER" | "GROUP_SUBSCRIPTION" | "COURSE_GIFT");
  cancelType?: ("B2B" | "B2C");
  isArchivable: boolean;
  isReviewable: boolean;
  review?: MyVoucherReviewDto;
  course: MyVoucherCourseDto;
  limitedAtUTC?: string
  | null
}


export interface MyVoucherOfflineCourseDto {
  id: number;
  startedAt: string;
  endedAt: string;
  hasSurveyAnswer: boolean;
  canAnswerSurvey: boolean;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface MyVoucherReviewDto {
  id: number;
  content: string;
  rating: number;
  reasons: string[]
}


export interface OffsetPageResponseMyVoucherDto {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyVoucherDto[]
}


export interface GetEnrollmentVerificationResponse {
  id: number;
  courseId: number;
  courseSlug: string;
  courseTitle: string;
  courseThumbnailUrl: string;
  isConfirmed: boolean;
  createdAt: string;
  createdAtUTC: string
}


export interface SearchSkillResponse {
  skills: SkillSummaryDto[]
}


export interface SkillSummaryDto {
  id: number;
  title: string;
  slug: string
}


export interface BankResponse {
  name: string;
  accountNumber: string;
  limitedAt: string;
  limitedAtUTC: string
}


export interface ChallengeInfoResponse {
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null;
  applyStartedAtUTC?: string
  | null;
  applyEndedAtUTC?: string
  | null
}


export interface CommonDiscountResponse {
  id?: number
  | null;
  title: string;
  type: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON");
  discountRate: number;
  discountPrice: number;
  discountStrategy: ("PERCENT" | "PRICE");
  couponId?: number
  | null
}


export interface CourseMetadataLevelResponse {
  code: string
}


export interface CourseMetadataResponse {
  skillTags: SkillTagResponse[];
  categories: OrderPaymentCommonCourseCategoryResponse[];
  levels: CourseMetadataLevelResponse[]
}


export interface CourseResponse {
  id: number;
  slug: string;
  title: string;
  type: ("ON" | "OFF" | "CHALLENGE");
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  studentCount: number;
  totalStar: number;
  reviewCount: number;
  likeCount: number;
  thumbnailUrl: string;
  publishedAt?: string
  | null;
  lastUpdatedAt?: string
  | null;
  revenueRatio: number;
  providesInstructorAnswer: boolean;
  instructor: InstructorResponse;
  metadata: CourseMetadataResponse;
  voucher?: VoucherResponse;
  offline?: OfflineInfoResponse;
  challenge?: ChallengeInfoResponse;
  publishedAtUTC: string;
  lastUpdatedAtUTC: string
}


export interface InstructorResponse {
  userId: number;
  userName: string;
  userSlug?: string
  | null
}


export interface MentoringCodeResponse {
  isProvided: boolean;
  isUsed: boolean
}


export interface OfflineInfoResponse {
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  surveyDueDateUTC?: string
  | null;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null;
  applyStartedAtUTC?: string
  | null;
  applyEndedAtUTC?: string
  | null
}


export interface OrderDetailPaymentResponse {
  id: number;
  userId: number;
  createdAt?: string
  | null;
  status: ("CANCEL_DELETE" | "MENTEE_CANCEL" | "PARTIAL_CANCEL" | "CANCEL_NOT_ENOUGH_PROGRESS" | "GROUP_PAYMENT_CANCEL" | "PAYMENT_CANCEL" | "ORDER_FORM" | "CONFLICT_CANCEL" | "AUTO_CANCEL" | "PAYMENT_READY" | "TOTAL_CANCEL" | "PAYMENT_FAIL" | "PAYMENT_STOP" | "CODE_ORDER" | "ORDER_CANCEL" | "PAYMENT_COMPLETE" | "PAYMENT_COMPLETE_PROCESSING" | "ADMIN_CANCEL" | "MENTOR_CANCEL" | "DEPOSIT_WAIT" | "WC_COMPLETED" | "MANUAL_DELETE" | "REFUND_REQUEST");
  paymentMethodType?: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "TOSSPAY" | "TOSS_PAY_MONEY" | "APPLEPAY" | "VIRTUAL_ACCOUNT" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "BANK_TRANSFER" | "PAYCO" | "UNKNOWN" | "NONE" | "LINKPAY" | "LINKPAY_NAVERPAY" | "LINKPAY_KAKAOPAY" | "LINKPAY_TOSSPAY" | "LINKPAY_PAYCO" | "LINKPAY_APPLEPAY" | "LINKPAY_CARD" | "LINKPAY_BANK_TRANSFER" | "FPX" | "SOFORT" | "PAYNOW" | "GRABPAYPH" | "GRABPAYMY" | "BOOST" | "TOUCHNGO" | "KONBINI" | "PAYSHOP" | "BANCONTACT" | "EPS" | "MULTIBANCO" | "PRZELEWY24" | "BLIK" | "IDEAL" | "PLATFORM" | "POLI" | "INSTANT_BANK_TRANSFER" | "UPI");
  regularPrice: number;
  paymentPrice: number;
  discountPrice: number;
  point: number;
  receiptUrl: string;
  isReceiptAvailable: boolean;
  canGetInvoice: boolean;
  isOldDataWithNoReceipt: boolean;
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  bank?: BankResponse;
  currency: ("KRW" | "USD" | "VND" | "JPY");
  timezone: string;
  paidAtUTC?: string
  | null;
  isGlobalPayment: boolean;
  refundedPoint: number;
  refundStatus: ("IDLE" | "PENDING" | "COMPLETE" | "REJECT");
  items: OrderItemResponse[];
  requestGift?: RequestGiftResponse;
  createdAtUTC: string
}


export interface OrderItemResponse {
  cartId: number;
  title: string;
  status: ("AUTO_CANCEL" | "REFUND" | "CANCEL" | "PAID" | "ADMIN_CANCEL" | "CANCEL_MENTOR" | "WC_COMPLETED" | "WAIT" | "MANUAL_DELETE" | "CANCEL_DELETE" | "CANCEL_PROGRESS" | "CANCEL_MENTEE" | "GROUP_PAYMENT_CANCEL" | "ORDER" | "ORDER_CANCEL");
  regularPrice: number;
  paymentPrice: number;
  courseId: number;
  krwRegularPrice: number;
  krwPaymentPrice: number;
  isRefundable: boolean;
  discount?: CommonDiscountResponse;
  mentoringCode: MentoringCodeResponse;
  course?: CourseResponse
}


export interface OrderPaymentCommonCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: ParentCategoryResponse
}


export interface ParentCategoryResponse {
  id: number;
  title: string;
  slug: string
}


export interface PayerResponse {
  name?: string
  | null;
  phone?: string
  | null
}


export interface PhotoCardResponse {
  id: number;
  imageUrl: string;
  message: string
}


export interface RequestGiftResponse {
  type: ("LINK" | "PHONE");
  paymentLink: string;
  createdAtUTC: string;
  expiredAtUTC: string;
  requester: RequesterResponse;
  payer: PayerResponse;
  photoCard: PhotoCardResponse
}


export interface RequesterResponse {
  name: string;
  email: string;
  phone: string;
  countryCode: string
}


export interface SkillTagResponse {
  id: number;
  title: string;
  slug: string
}


export interface VoucherResponse {
  hasDownloadResource: boolean;
  hasDownloadVideo: boolean;
  progress: string;
  createdAt?: string
  | null;
  limitedAt?: string
  | null;
  createdAtUTC: string;
  limitedAtUTC?: string
  | null
}


export interface GetMyRoadmapResponseV2 {
  id: number;
  status: ("DRAFT" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PRIVATE");
  accessCode?: string
  | null;
  title: string;
  thumbnail?: Thumbnail;
  jsonDescription: string;
  htmlDescription: string;
  items: RoadmapItemResponse[];
  latestPublishedHistory?: PublishedHistory
}


export interface PublishedHistory {
  id: number;
  name: string;
  savedAt: string;
  savedAtUTC: string
}


export interface RoadmapBookResponse {
  thumbnailUrl: string;
  url: string;
  authors: string[];
  translators: string[];
  publisher: string;
  isbn: string
}


export interface RoadmapCourseResponse {
  id: number;
  thumbnailUrl: string;
  instructorName: string
}


export interface RoadmapItemResponse {
  id: number;
  title: string;
  description: string;
  type: ("COURSE" | "BOOK" | "LINK");
  course?: RoadmapCourseResponse;
  book?: RoadmapBookResponse;
  link?: RoadmapLinkResponse
}


export interface RoadmapLinkResponse {
  thumbnailUrl: string;
  url: string;
  iconUrl?: string
  | null
}


export interface Thumbnail {
  id: number;
  url: string
}


export interface LatestRoadmapHistoryResponse {
  id: number;
  status: ("RESTORE" | "PUBLISH" | "DRAFT");
  accessCode?: string
  | null;
  title?: string
  | null;
  thumbnail: Thumbnail;
  jsonDescription?: string
  | null;
  htmlDescription?: string
  | null;
  savedAt: string;
  items: RoadmapItemResponse[];
  savedAtUTC: string
}


export interface CourseTitle {
  desanitized?: string
  | null;
  sanitized?: string
  | null
}


export interface FindMyListCourseInfo {
  id: number;
  thumbnailUrl: string;
  courseTitle?: CourseTitle;
  slug: string;
  courseInstructorName?: string
  | null;
  courseInstructorSlug?: string
  | null;
  language?: ("KO" | "EN" | "JA" | "VI");
  duration?: number
  | null;
  totalStar?: number
  | null;
  reviewCount?: number
  | null;
  tags: string[];
  lectureCount: number;
  canStudy: boolean;
  voucher?: FindMyListCourseVoucherInfo;
  title: string;
  expireInMonth?: number
  | null;
  rating: number;
  instructorName: string
}


export interface FindMyListCourseVoucherInfo {
  limitedAt?: string
  | null;
  completedLectureCount: number;
  progress: number;
  lastUnitId?: number
  | null;
  limitedAtUTC?: string
  | null
}


export interface FindMyListCoursesResponse {
  id: number;
  myListTitle?: MyListTitle;
  courses: FindMyListCourseInfo[];
  title: string
}


export interface MyListTitle {
  value: string;
  desanitized: string
}


export interface CourseByUserItemResponse {
  id: number;
  title: string;
  slug: string;
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  vodOriginalLanguage: ("KO" | "EN" | "JA" | "VI" | "CN" | "TW" | "HI" | "FR" | "CA" | "ES" | "MX" | "PT");
  type: ("ON" | "OFF" | "CHALLENGE");
  thumbnailUrl: string
}


export interface CourseByUserResponse {
  items: CourseByUserItemResponse[]
}


export interface CourseQuizSummaryResponse {
  totalQuestionCount: number;
  totalCorrectCount: number;
  isAllCompleted: boolean;
  score: number;
  correctRate: number
}


export interface CourseStepResponse {
  info: boolean;
  curriculum: boolean;
  detail: boolean;
  coverImage: boolean;
  setting: boolean;
  autoMessage: boolean;
  faq: boolean;
  instructor: boolean
}


export interface ChallengeCourseResponse {
  originalCourseId?: number
  | null
}


export interface CourseCategoryTitleResponse {
  firstCategory: string[];
  secondCategory: string[]
}


export interface CourseInstructorResponse {
  id: number;
  name: string;
  slug?: string
  | null
}


export interface CourseOneByInstructorLevelResponse {
  level: string;
  levelCode: string
}


export interface CourseOneByInstructorResponse {
  id: number;
  type: ("ON" | "OFF" | "CHALLENGE");
  title: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  slug: string;
  price?: number
  | null;
  sourceCurrency: ("KRW" | "USD" | "VND" | "JPY");
  duration?: number
  | null;
  courseType: ("ONLINE" | "CLASS" | "CONFERENCE" | "CHALLENGE");
  skills: CourseSkillOneResponse[];
  representativeInstructor: CourseInstructorResponse;
  category: CourseCategoryTitleResponse;
  thumbnailUrl: string;
  levels: CourseOneByInstructorLevelResponse[];
  discountedPrice?: number
  | null;
  discountStartedAtUTC?: string
  | null;
  discountEndedAtUTC?: string
  | null;
  instructorCount: number;
  studentCount: number;
  appliedStudentCount: number;
  targetPublishAtUTC?: string
  | null;
  submittedAtUTC?: string
  | null;
  challengeCourse?: ChallengeCourseResponse
}


export interface CourseSkillOneResponse {
  id: number;
  title: string;
  slug: string;
  subTitle: string
}


export interface CurriculumLectureUnitResponse {
  id: number;
  title: string;
  type: ("SECTION" | "LECTURE" | "MISSION" | "DOCUMENT" | "QUIZ" | "LIVE_SESSION" | "LABLUP");
  runtime: number;
  isPreview: boolean;
  hasAttachment: boolean;
  isComplete: boolean;
  body?: string
  | null;
  hasBody: boolean;
  hasVideo: boolean;
  submissionStatus?: ("NONE" | "DRAFT" | "REJECTED" | "SUBMITTED" | "ACCEPTED");
  quizId?: number
  | null;
  quizStatus?: QuizStatusResponse;
  isChallengeOnly: boolean;
  liveSession?: CurriculumLiveSessionResponse;
  readingTime?: number
  | null
}


export interface CurriculumLiveSessionResponse {
  status: ("NOT_STARTED" | "ON_LIVE" | "ENDED");
  attendanceStatus: ("NONE" | "ATTENDED" | "ABSENT");
  recordingOption: ("PROVIDED" | "NOT_PROVIDED");
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface CurriculumSectionResponse {
  id: number;
  title: string;
  units: CurriculumLectureUnitResponse[]
}


export interface GetCurriculumResponse {
  publishedAt: string;
  lastUpdatedAt: string;
  curriculum: CurriculumSectionResponse[];
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string
}


export interface QuizStatusResponse {
  status: ("IN_PROGRESS" | "RETRYING" | "COMPLETED");
  progress: number;
  correctCount: number;
  questionCount: number;
  retryable: boolean;
  retryCount: number;
  isCompleted: boolean;
  score: number
}


export interface FaqResponse {
  title: string;
  body: string
}


export interface GetContentsChallengeCourseInfo {
  originalCourseId?: number
  | null;
  originalCourseTitle?: string
  | null;
  originalCourseSlug?: string
  | null;
  challengePeriod?: Period;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface GetContentsResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  level: string;
  levelCode: string;
  description: string;
  body: string;
  editorType: ("EDITOR" | "BUILDER");
  shownCategory: string[];
  abilities: string[];
  targets: string[];
  based: string[];
  faqs: FaqResponse[];
  mainInstructors: MainInstructorWithStatResponse[];
  challengeCourse?: GetContentsChallengeCourseInfo;
  publishedAt?: string
  | null;
  lastUpdatedAt: string;
  lastUpdatedAtUTC: string;
  publishedAtUTC?: string
  | null
}


export interface MainInstructorWithStatResponse {
  id: number;
  name: string;
  slug: string;
  introduce: string;
  thumbnail: string;
  courseCount?: number
  | null;
  studentCount?: number
  | null;
  reviewCount?: number
  | null;
  totalStar?: number
  | null;
  answerCount?: number
  | null
}


export interface Period {
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  days?: number
  | null;
  valid?: boolean
  | null;
  periodDays?: number
  | null;
  none?: boolean
  | null;
  within?: boolean
  | null
}


export interface BaseCourseChallengeResponse {
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  applyStartedAt?: string
  | null;
  applyEndedAt?: string
  | null;
  applyClosedAt?: string
  | null;
  capacity: number;
  appliedStudentCount: number;
  displayRemainingApplicantCount?: number
  | null;
  hasSurveyAnswer: boolean;
  benefits: ChallengeBenefitResponse[];
  originalCourseId?: number
  | null;
  inquiryEmail?: string
  | null;
  inquiryLinkUrl?: string
  | null;
  startedAtUTC: string;
  endedAtUTC: string;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  applyClosedAtUTC?: string
  | null
}


export interface CartResponse {
  id: number
}


export interface ChallengeBenefitResponse {
  title: string;
  type: string;
  iconType: string
}


export interface CourseCategoryResponse {
  main: CourseCategoryTitleWithSlug;
  sub: CourseCategoryTitleWithSlug
}


export interface CourseCategoryTitleWithSlug {
  title: string;
  slug: string
}


export interface CourseLevelResponse {
  title: string;
  code: string;
  slug: string;
  isActive: boolean
}


export interface CoursePaymentResponse {
  type: ("ENROLLED" | "PURCHASE_UNAVAILABLE" | "B2B_SUBSCRIPTION" | "B2B_ENROLMENT_PENDING" | "B2B_PURCHASE" | "B2B_PURCHASE_RESTRICTED" | "FREE" | "DISCOUNTED_PURCHASE" | "REGULAR_PRICE_PURCHASE");
  regularPrice: number;
  payPrice: number;
  discountRate: number;
  discount?: DiscountInfoResponse;
  group?: GroupResponse;
  krwRegularPrice: number;
  krwPaymentPrice: number
}


export interface CourseVoucherResponseV2 {
  isValid: boolean;
  progress: string;
  completeCount: number
}


export interface DiscountInfoResponse {
  title: string;
  endedAt: string;
  type: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON");
  discountId?: number
  | null;
  endedAtUTC: string
}


export interface GetChallengeCourseDetailInfoResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  id: number;
  slug?: string
  | null;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  studentCount: number;
  duration?: number
  | null;
  providesCertificate: boolean;
  providesInstructorAnswer: boolean;
  providesInquiry: boolean;
  isLiked: boolean;
  likeCount: number;
  description: string;
  unitSummary: UnitSummaryResponse;
  groupEnrolment?: GroupEnrolmentResponse;
  cart?: CartResponse;
  category: CourseCategoryResponse;
  voucher?: CourseVoucherResponseV2;
  paymentInfo: CoursePaymentResponse;
  review: ReviewResponse;
  instructors: CourseInstructorResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[];
  publishedAt?: string
  | null;
  lastUpdatedAt?: string
  | null;
  commonTags: CommonTagResponse[];
  isGiftable?: boolean
  | null;
  isRequestGiftable: boolean;
  courseType: ("ON" | "OFF" | "CHALLENGE");
  challenge: BaseCourseChallengeResponse;
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string
}


export interface GroupEnrolmentResponse {
  id: number
}


export interface GroupResponse {
  name: string;
  approvalRequired: boolean;
  hidePrice: boolean
}


export interface ReviewResponse {
  isShowing: boolean;
  count: number;
  averageStar: number
}


export interface UnitSummaryResponse {
  lectureUnitCount: number;
  missionUnitCount: number;
  challengeUnitCount: number;
  liveSessionUnitCount: number;
  /**
   * previewVideoLectureCount를 사용해주세요
   */
  previewVideoUnitCount: number;
  previewUnitCount: number;
  previewVideoLectureCount: number;
  runtime: number;
  hasIntroVideo: boolean;
  totalPreviewVideoCount: number
}


export interface GetChallengePersonalInfoResponse {
  isLiked: boolean;
  voucher?: CourseVoucherResponseV2;
  cart?: CartResponse;
  paymentInfo: CoursePaymentResponse;
  survey: SurveyResponse
}


export interface SurveyResponse {
  hasSurveyAnswer: boolean
}


export interface CourseCardCartResponse {
  isInCart: boolean;
  canUseCart: boolean
}


export interface CourseCardChallengeCourseResponse {
  applyStartedAt?: string
  | null;
  applyEndedAt?: string
  | null;
  eventStartedAt?: string
  | null;
  eventEndedAt?: string
  | null;
  challengeStatus?: ("BEFORE_APPLY" | "APPLYING" | "AFTER_APPLY" | "PROCESSING" | "PARTICIPATING" | "COMPLETED");
  capacity: number;
  originalCourseStudentCount: number;
  applicantCount: number;
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  eventStartedAtUTC: string;
  eventEndedAtUTC: string
}


export interface CourseCardCoursePriceResponse {
  isDiscount: boolean;
  isEarlyBirdDiscount: boolean;
  payPrice: number;
  regularPrice: number;
  isFree: boolean;
  discountRate: number;
  discountEndedAt?: string
  | null;
  discountId?: number
  | null;
  discountTitle?: string
  | null;
  discountEndedAtUTC?: string
  | null
}


export interface CourseCardCourseResponse {
  id: number;
  slug: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  reviewCount: number;
  studentCount: number;
  likeCount: number;
  star: number;
  isExclusive: boolean;
  isNew: boolean;
  isUpdated: boolean;
  updatedAt: string;
  publishedAt?: string
  | null;
  metadata: SearchCourseMetadataResponse;
  abilities: string[];
  courseTags: CourseTagResponse[];
  targets: string[];
  runtimeSecond: number;
  updatedAtUTC: string;
  publishedAtUTC?: string
  | null
}


export interface CourseCardInstructorResponse {
  id: number;
  name: string
}


export interface CourseCardItem {
  id: number;
  type: ("ON" | "OFF" | "CHALLENGE");
  tagTitles: string[];
  isHidePrice: boolean;
  hasMyReaction: boolean;
  hasMentoring: boolean;
  isKdt: boolean;
  offlineCourse?: CourseCardOfflineCourseResponse;
  challengeCourse?: CourseCardChallengeCourseResponse;
  course: CourseCardCourseResponse;
  instructor: CourseCardInstructorResponse;
  listPrice: CourseCardCoursePriceResponse;
  cart: CourseCardCartResponse;
  voucher?: CourseCardVoucherResponse;
  krwRegularPrice: number;
  krwPaymentPrice: number
}


export interface CourseCardItemCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: ParentCategoryResponse
}


export interface CourseCardOfflineCourseResponse {
  type: ("CONFERENCE" | "CLASS");
  applyStartedAt: string;
  applyEndedAt: string;
  eventStartedAt: string;
  eventEndedAt: string;
  capacity: number;
  applicantCount: number;
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  eventStartedAtUTC: string;
  eventEndedAtUTC: string
}


export interface CourseCardVoucherResponse {
  completeCount: number;
  lectureCount: number;
  progress: string
}


export interface CourseTagResponse {
  tag: ("IS_ACTIVE_IN_QUESTION" | "IS_B2B_SUBSCRIPTION" | "HAS_MISSION" | "IS_CHALLENGE_APPLYING" | "IS_CHALLENGE_BEFORE_APPLY" | "IS_CHALLENGE_AFTER_APPLY" | "IS_CHALLENGE_PROCESSING" | "IS_CHALLENGE_COMPLETED" | "IS_CHALLENGE_PARTICIPATING")
}


export interface SearchCourseMetadataResponse {
  level: string;
  levelCode: string;
  /**
   * Use skillTags instead
   */
  skills: string[];
  skillTags: SkillTagResponse[];
  categories: CourseCardItemCourseCategoryResponse[];
  /**
   * Use categories instead
   */
  parentCategories: string[];
  /**
   * Use categories instead
   */
  childCategories: string[]
}


export interface SearchCourseResponse {
  attributionToken: string;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[]
}


export interface CategoryInfo {
  id: number;
  slug: string;
  title: string
}


export interface ChallengeCourseRecommendResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: RecommendedChallenge[];
  attributionToken: string
}


export interface InstructorInfo {
  id: number;
  name: string;
  slug?: string
  | null
}


export interface RecommendedChallenge {
  id: number;
  isNew: boolean;
  thumbnailUrl?: string
  | null;
  title: string;
  slug: string;
  description?: string
  | null;
  instructor: InstructorInfo;
  representativeCategory: CategoryInfo;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  applyClosedAtUTC?: string
  | null;
  eventStartedAtUTC: string;
  eventEndedAtUTC: string;
  price: number;
  regularPrice: number;
  payPrice: number;
  discountRate?: number
  | null;
  isFree: boolean;
  isDiscounting: boolean;
  hasLiveSession: boolean;
  isApplyEnded: boolean;
  challengeStatus: ("BEFORE_APPLY" | "APPLYING" | "AFTER_APPLY" | "PROCESSING" | "PARTICIPATING" | "COMPLETED");
  capacity: number;
  applicantCount: number;
  displayRemainingApplicantCount?: number
  | null;
  level: string;
  levelCode: string;
  challengeDurationDays: number;
  applicantRate: number
}


export interface RecentLearningResponse {
  unitId?: number
  | null;
  courseSlug: string
}


export interface FindMyRecentLearningVoucherResponse {
  items: VoucherAndCourse[];
  isRecentLearned: boolean
}


export interface VoucherAndCourse {
  id: number;
  courseId: number;
  courseSlug: string;
  title?: CourseTitle;
  courseLectureCount: number;
  courseThumbnailUrl: string;
  progress: string;
  completeCount: number;
  unitId: number;
  accessedAtRaw?: string
  | null;
  instructorUserId: number;
  instructorUserName: string;
  mainCourseCategory: string;
  courseTitle: string;
  accessedAt: string;
  accessedAtUTC: string
}


export interface FindMyChallengeVoucherByCursorResponse {
  pageSize: number;
  nextCursor?: string
  | null;
  hasNext: boolean;
  items: MyChallengeVoucherDto[]
}


export interface LiveSessionInfo {
  id: number;
  unitId: number;
  title: string;
  startedAt: string;
  isParticipated: boolean;
  status: ("NOT_STARTED" | "ROOM_OPENED" | "ROOM_ENDED");
  startedAtUTC: string
}


export interface MissionInfo {
  id: number;
  unitId: number;
  submissionStatus?: ("DRAFT" | "REJECTED" | "SUBMITTED" | "ACCEPTED")
}


export interface MyChallengeVoucherChallengeCourseDto {
  id: number;
  startedAt: string;
  endedAt: string;
  status: ("NOT_STARTED" | "IN_PROGRESS" | "ENDED");
  missions: MissionInfo[];
  liveSessions: LiveSessionInfo[];
  survey: SurveyInfo;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface MyChallengeVoucherCourseDto {
  id: number;
  slug: string;
  title: string;
  lectureCount: number;
  thumbnailUrl: string;
  instructorId: number;
  instructorName: string;
  challengeCourse: MyChallengeVoucherChallengeCourseDto;
  childCategories: string[]
}


export interface MyChallengeVoucherDto {
  id: number;
  userId: number;
  unitId: number;
  progress: string;
  completeCount: number;
  limitedAt?: string
  | null;
  isArchived: boolean;
  hasCertificate: boolean;
  type: ("LEGACY" | "IS_ADMIN" | "BY_ADMIN" | "IS_INSTRUCTOR" | "BY_INSTRUCTOR" | "FREE" | "ORDER" | "CODE" | "GROUP_ORDER" | "GROUP_SUBSCRIPTION" | "COURSE_GIFT");
  cancelType?: ("B2B" | "B2C");
  isArchivable: boolean;
  isReviewable: boolean;
  review?: MyVoucherReviewDto;
  course: MyChallengeVoucherCourseDto;
  limitedAtUTC?: string
  | null
}


export interface SurveyInfo {
  hasSurveyAnswer: boolean
}


export interface FindMyVoucherByCursorResponse {
  pageSize: number;
  nextCursor?: string
  | null;
  hasNext: boolean;
  items: MyVoucherDto[]
}


export interface CourseChallengeItemResponse {
  id: number;
  userId: number;
  userName: string;
  appliedAt?: string
  | null;
  paidAt?: string
  | null;
  surveyAnswer?: SurveyAnswerResponse;
  progress: string;
  lectureCount: number;
  missionCount: number;
  liveSessionCount: number;
  completedLectureCount: number;
  completedMissionCount: number;
  completedLiveSessionCount: number;
  isCertificateIssued: boolean;
  isAdmin: boolean;
  appliedAtUTC: string;
  paidAtUTC?: string
  | null
}


export interface CourseChallengeResponse {
  page?: PageCourseChallengeItemResponse;
  instructorCount: number;
  adminCount: number;
  allCount: number;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseChallengeItemResponse[]
}


export interface PageCourseChallengeItemResponse {
  totalElements?: number
  | null;
  totalPages?: number
  | null;
  size?: number
  | null;
  content?: CourseChallengeItemResponse[]
  | null;
  number?: number
  | null;
  sort?: SortObject;
  first?: boolean
  | null;
  last?: boolean
  | null;
  numberOfElements?: number
  | null;
  pageable?: PageableObject;
  empty?: boolean
  | null
}


export interface PageableObject {
  offset?: number
  | null;
  sort?: SortObject;
  paged?: boolean
  | null;
  pageSize?: number
  | null;
  pageNumber?: number
  | null;
  unpaged?: boolean
  | null
}


export interface SortObject {
  empty?: boolean
  | null;
  sorted?: boolean
  | null;
  unsorted?: boolean
  | null
}


export interface SurveyAnswerResponse {
  surveyId: number;
  name: string;
  email: string;
  phone: string
}


export interface FindMyVoucherCategoryResponse {
  items: FindVoucherCourseCategoryResult[]
}


export interface FindVoucherCourseCategoryResult {
  id: number;
  title: string;
  count: number
}


export interface UserStatisticsResponse {
  userCourses: number[];
  userCourseCnt: number;
  userCourseTotalPaymentPrice: number;
  preferCategories: string[]
}


export interface FindSkillResponse {
  skills: SkillSummaryDto[]
}


export interface FindSettlementProductResponse {
  items: SettlementProduct[]
}


export interface SettlementProduct {
  id: number;
  productType: ("ONLINE_COURSE" | "OFFLINE_COURSE" | "MENTORING");
  productTitle: string
}


export interface SectionOneSummaryResponse {
  summaryContents: SummaryDetail[]
}


export interface SummaryContent {
  title: string;
  startSeconds?: number
  | null;
  endSeconds?: number
  | null;
  content: string
}


export interface SummaryDetail {
  id: number;
  unitId: number;
  unitTitle: string;
  type: ("VOD_SUBTITLE" | "UNIT_BODY");
  contents: SummaryContent[];
  hasReaction: boolean;
  reactionType?: ("LIKE" | "DISLIKE");
  sequence: number
}


export interface SectionDetail {
  id: number;
  title: string;
  isSummaryVisible: boolean
}


export interface SectionWithSummaryInfoResponse {
  sections: SectionDetail[]
}


export interface MyRoadmapDto {
  id: number;
  latestHistoryId?: number
  | null;
  title: string;
  enrolledCount: number;
  commentCount: number;
  type: ("EDITOR" | "BUILDER");
  status: ("DRAFT" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PRIVATE");
  createdAt: string;
  updatedAt: string;
  isRemovable: boolean;
  createdAtUTC: string;
  updatedAtUTC: string
}


export interface OffsetPageResponseMyRoadmapDto {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyRoadmapDto[]
}


export interface RoadmapSummaryDto {
  id: number;
  title: string;
  likeCount: number;
  enrollCount: number;
  authorName: string;
  authorThumbnailUrl: string;
  thumbnailUrl: string;
  /**
   * Use authorName instead
   */
  userName: string;
  /**
   * Use thumbnailUrl instead
   */
  coverFileUrl: string
}


export interface RoadmapSummaryListResponse {
  items: RoadmapSummaryDto[]
}


export interface SearchRoadmapResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: SearchedRoadmapCard[]
}


export interface SearchedRoadmapCard {
  id: number;
  title: string;
  thumbnail: string;
  authorName: string;
  authorThumbnail: string;
  enrollCount: number;
  isEnrolled: boolean;
  roadmapItems: SearchedRoadmapItemDto[];
  skills: SearchedRoadmapSkillDto[];
  coupon?: SearchedRoadmapCouponDto
}


export interface SearchedRoadmapCouponDiscountDto {
  type: ("PERCENT" | "PRICE");
  value: number
}


export interface SearchedRoadmapCouponDto {
  id: number;
  discount: SearchedRoadmapCouponDiscountDto;
  isUnlimited: boolean;
  remainCount: number;
  displayRemainCount: number
}


export interface SearchedRoadmapItemDto {
  id: number;
  type: ("COURSE" | "BOOK" | "LINK");
  title: string;
  thumbnail: string;
  instructorName?: string
  | null
}


export interface SearchedRoadmapSkillDto {
  id: number;
  title: string
}


export interface EnrolledRoadmapDto {
  id: number;
  title: string;
  courseCount: number;
  completedCourseCount: number;
  thumbnailUrl: string;
  authorName: string;
  completeCount: number;
  lectureCount: number;
  firstCourseId?: number
  | null;
  recentCourseId?: number
  | null
}


export interface OffsetPageResponseEnrolledRoadmapDto {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: EnrolledRoadmapDto[]
}


export interface RoadmapsByAuthorResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: RoadmapSummaryDto[]
}


export interface FindRoadmapHistoriesResponse {
  id: number;
  name: string;
  savedAt: string;
  type: ("RESTORE" | "PUBLISH" | "DRAFT");
  userName: string;
  userId: number;
  origin?: RoadmapHistoryOrigin;
  savedAtUTC: string
}


export interface RoadmapHistoryOrigin {
  id: number;
  name: string;
  savedAt: string;
  type: ("RESTORE" | "PUBLISH" | "DRAFT");
  userName: string;
  userId: number;
  savedAtUTC: string
}


export interface FindRegistrableRoadmapCourseResponse {
  totalCount: number;
  pageSize: number;
  nextCursor?: string
  | null;
  hasNext: boolean;
  items: RegistrableCourseDto[]
}


export interface RegistrableCourseDto {
  id: number;
  title: string;
  slug: string;
  description: string;
  thumbnailUrl: string;
  instructorName: string
}


export interface FindRoadmapContentTemplateResponse {
  id: number;
  title: string;
  authorType: ("INFLAB" | "USER");
  htmlDescription: string;
  jsonDescription: string;
  createdAt: string;
  createdAtUTC: string
}


export interface OffsetPageResponseFindRoadmapContentTemplateResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: FindRoadmapContentTemplateResponse[]
}


export interface CourseReviewInfo {
  id: number;
  rating: number;
  content: string;
  createdAtUTC: string;
  displayCreatedAt: string
}


export interface DisplayTotalStudyingTime {
  hours: number;
  minutes: number
}


export interface FirstUnitCompleteInfo {
  id: number;
  courseId: number;
  courseTitle: string;
  courseThumbnail: string;
  representativeInstructorName: string;
  completedAtUTC: string;
  displayFirstUnitCompleteDate: string
}


export interface GetRecap2025CourseInfo {
  id: number;
  title: string;
  thumbnail: string;
  representativeInstructorName: string
}


export interface GetRecap2025Response {
  rank: ("MASTER" | "SCHOLAR" | "SKILL_BUILDER" | "LEARNER" | "STARTER");
  totalStudyingTimeSeconds: number;
  totalStudyingCourseCount: number;
  studyingCourses: GetRecap2025CourseInfo[];
  totalCompleteCourseCount: number;
  completeCourses: GetRecap2025CourseInfo[];
  totalSkillTagCount: number;
  skillTags: SkillTagInfo[];
  firstUnitComplete: FirstUnitCompleteInfo;
  totalInstructorCount: number;
  instructors: InstructorInfo[];
  maxCompleteCourseInstructor: InstructorInfo;
  maxStudyingTimeCompletedAt?: string
  | null;
  maxStudyingTimeMonths: number[];
  maxStudyingTimeDayOfWeek: ("MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY");
  maxStudyingTimeTimeOfDay: ("EARLY_MORNING" | "MORNING" | "AFTERNOON" | "EVENING" | "NIGHT" | "DAWN");
  maxContinuousStudyDay: number;
  totalCourseReviewCount: number;
  courseReviews: CourseReviewInfo[];
  totalQuestionCount: number;
  questions: QuestionInfo[];
  totalNoteCount: number;
  displayTotalStudyingTime: DisplayTotalStudyingTime;
  maxStudyingTimeCompletedAtUTC: string;
  displayMaxStudyingTimeCompletedAtDate: string;
  displayMaxStudyingTimeMonths: string;
  displayMaxStudyingTimeTimeOfDayTime: string;
  displayMaxStudyingTimeTimeOfDayTimeSlot: string;
  displayMaxStudyingTimeDayOfWeek: string
}


export interface QuestionInfo {
  id: number;
  title: string;
  createdAtUTC: string;
  displayCreatedAt: string
}


export interface SkillTagInfo {
  id: number;
  title: string
}


export interface CheckRecap2025ExistsResponse {
  hasRecap: boolean
}


export interface QuizFindOneResponse {
  id: number;
  quizUserStatus: ("IN_PROGRESS" | "RETRYING" | "COMPLETED");
  questions: QuizQuestionOneResponse[]
}


export interface QuizQuestionChoiceOneResponse {
  id: number;
  content: string
}


export interface QuizQuestionOneResponse {
  id: number;
  title: string;
  choices: QuizQuestionChoiceOneResponse[];
  retryCount: number;
  quizQuestionUserStatus: ("PASS" | "FAIL" | "NOT_ATTEMPTED");
  reactionType?: ("LIKE" | "DISLIKE");
  hasReaction: boolean
}


export interface QuizLectureUserStatsResponse {
  quizId: number;
  correctCount: number;
  questionCount: number;
  retryLeftCount: number;
  retryable: boolean
}


export interface QuizFindOneStatusResponse {
  status: ("NOT_STARTED" | "NO_PERMISSION" | "IN_PROGRESS" | "COMPLETED")
}


export interface QuizFindOneQuestion {
  questionId: number;
  questionUserId: number;
  title: string;
  explanation?: string
  | null;
  lastChoiceId: number;
  status: ("PASS" | "FAIL" | "NOT_ATTEMPTED");
  choices: QuizFindOneResultChoice[];
  reactionType?: ("LIKE" | "DISLIKE");
  hasReaction: boolean
}


export interface QuizFindOneResultChoice {
  sequence: number;
  content: string;
  choiceId: number;
  isAnswer?: boolean
  | null
}


export interface QuizFindOneResultResponse {
  id: number;
  questions: QuizFindOneQuestion[];
  retryLeftCount: number;
  retryable: boolean
}


export interface EntryMarketingPartnerResponse {
  id: number;
  userId: number;
  name: string;
  type: ("BUSINESS" | "PERSONAL")
}


export interface EntryPromotionLinkResponse {
  id: number
}


export interface InstructorPromotionLinkEntryCourseResponse {
  id: number;
  title: string;
  slug: string
}


export interface InstructorPromotionLinkEntryEventsDetailResponseItem {
  entryAt: string;
  code: string;
  expiredAt?: string
  | null;
  course?: InstructorPromotionLinkEntryCourseResponse
}


export interface MarketingPromotionLinkEntryCourseResponse {
  id: number;
  title: string;
  slug: string;
  isInflearnMarketingAgreed: boolean
}


export interface MarketingPromotionLinkEntryEventDetailResponseItem {
  entryAt: string;
  code: string;
  expiredAt?: string
  | null;
  course?: MarketingPromotionLinkEntryCourseResponse;
  promotionLink?: EntryPromotionLinkResponse;
  marketingPartner?: EntryMarketingPartnerResponse
}


export interface PromotionLinkEntryEventsDetailResponse {
  instructorPromotionLinkEntryEvents: InstructorPromotionLinkEntryEventsDetailResponseItem[];
  marketingPromotionLinkEntryEvents: MarketingPromotionLinkEntryEventDetailResponseItem[]
}


export interface SearchPromotionCardsResponse {
  items: SearchPromotionItem[]
}


export interface SearchPromotionCourseItem {
  tagTitle: string;
  course: CourseCardItem
}


export interface SearchPromotionItem {
  id: number;
  type: ("COURSE" | "URL");
  course?: SearchPromotionCourseItem;
  url?: SearchPromotionUrlItem;
  title: string;
  sequence: number
}


export interface SearchPromotionUrlItem {
  image: string;
  altText: string;
  url: string
}


export interface CourseBanner {
  id: number;
  courseId: number;
  title: string;
  description: string;
  slug: string;
  thumbnailUrl: string;
  discount?: DiscountInfo;
  tagTitle: string;
  endedAtUTC?: string
  | null;
  startedAtUTC: string
}


export interface DiscountInfo {
  isEarlyBirdDiscount: boolean;
  title: string;
  rate: number;
  endedAtUTC: string
}


export interface FindPromotionBannerListResponse {
  items: PromotionBannerItem[]
}


export interface PromotionBannerItem {
  type: ("COURSE" | "URL");
  course?: CourseBanner;
  url?: UrlBanner
}


export interface UrlBanner {
  id: number;
  bannerTitle?: string
  | null;
  url: string;
  altText: string;
  bannerImageId: number;
  bannerImageUrl: string;
  bannerMobileImageId: number;
  bannerMobileImageUrl: string;
  isDDayActive: boolean;
  endedAtUTC?: string
  | null;
  startedAtUTC: string
}


export interface GetMyPointsResponse {
  point: number
}


export interface GetPaymentRequestStatusResponse {
  status: ("CANCEL_DELETE" | "MENTEE_CANCEL" | "PARTIAL_CANCEL" | "CANCEL_NOT_ENOUGH_PROGRESS" | "GROUP_PAYMENT_CANCEL" | "PAYMENT_CANCEL" | "ORDER_FORM" | "CONFLICT_CANCEL" | "AUTO_CANCEL" | "PAYMENT_READY" | "TOTAL_CANCEL" | "PAYMENT_FAIL" | "PAYMENT_STOP" | "CODE_ORDER" | "ORDER_CANCEL" | "PAYMENT_COMPLETE" | "PAYMENT_COMPLETE_PROCESSING" | "ADMIN_CANCEL" | "MENTOR_CANCEL" | "DEPOSIT_WAIT" | "WC_COMPLETED" | "MANUAL_DELETE" | "REFUND_REQUEST");
  requesterName: string;
  createdAtUTC: string;
  paymentPrice: number;
  orderId: number
}


export interface GetPaymentRequestCouponEligibilityResponse {
  requesterName: string;
  discountPercent: number;
  expireOffsetDay: number
}


export interface GetValidPaymentRequestResponse {
  paymentUrl: string;
  expiredAtUTC: string;
  createdAtUTC: string;
  requesterName: string;
  photoCard: PhotoCardResponse
}


export interface GetPaymentRequestPhotoCardsResponse {
  items: PaymentRequestPhotoCardResponse[]
}


export interface PaymentRequestPhotoCardResponse {
  id: number;
  title: string;
  url: string;
  isDefault: boolean
}


export interface FindOrderSummaryResponse {
  items: OrderSummaryDto[];
  statistics: UserPurchaseStatisticsResult
}


export interface OrderSummaryDto {
  id: number;
  title: string;
  createdAt: string;
  status: ("CANCEL_DELETE" | "MENTEE_CANCEL" | "PARTIAL_CANCEL" | "CANCEL_NOT_ENOUGH_PROGRESS" | "GROUP_PAYMENT_CANCEL" | "PAYMENT_CANCEL" | "ORDER_FORM" | "CONFLICT_CANCEL" | "AUTO_CANCEL" | "PAYMENT_READY" | "TOTAL_CANCEL" | "PAYMENT_FAIL" | "PAYMENT_STOP" | "CODE_ORDER" | "ORDER_CANCEL" | "PAYMENT_COMPLETE" | "PAYMENT_COMPLETE_PROCESSING" | "ADMIN_CANCEL" | "MENTOR_CANCEL" | "DEPOSIT_WAIT" | "WC_COMPLETED" | "MANUAL_DELETE" | "REFUND_REQUEST");
  orderMode: ("NORMAL" | "B2B_CODE" | "B2C_CODE" | "CODE" | "MENTOR" | "MENTORING" | "COURSE_GIFT" | "CLIP");
  regularPrice: number;
  paymentPrice: number;
  itemsCount: number;
  receiptUrl: string;
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  paymentMethodType?: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "TOSSPAY" | "TOSS_PAY_MONEY" | "APPLEPAY" | "VIRTUAL_ACCOUNT" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "BANK_TRANSFER" | "PAYCO" | "UNKNOWN" | "NONE" | "LINKPAY" | "LINKPAY_NAVERPAY" | "LINKPAY_KAKAOPAY" | "LINKPAY_TOSSPAY" | "LINKPAY_PAYCO" | "LINKPAY_APPLEPAY" | "LINKPAY_CARD" | "LINKPAY_BANK_TRANSFER" | "FPX" | "SOFORT" | "PAYNOW" | "GRABPAYPH" | "GRABPAYMY" | "BOOST" | "TOUCHNGO" | "KONBINI" | "PAYSHOP" | "BANCONTACT" | "EPS" | "MULTIBANCO" | "PRZELEWY24" | "BLIK" | "IDEAL" | "PLATFORM" | "POLI" | "INSTANT_BANK_TRANSFER" | "UPI");
  /**
   * use isReceiptAvailable
   */
  canGetReceipt: boolean;
  isReceiptAvailable: boolean;
  canGetInvoice: boolean;
  isOldDataWithNoReceipt: boolean;
  currency: ("KRW" | "USD" | "VND" | "JPY");
  timezone: string;
  createdAtUTC: string;
  isPaymentRequest: boolean
}


export interface UserPurchaseStatisticsResult {
  totalCount: number;
  totalOrderAmount: number;
  totalPaymentAmount: number;
  totalDiscountAmount: number
}


export interface OfflineCourseStepResponse {
  info: boolean;
  detail: boolean;
  curriculum: boolean;
  survey: boolean;
  coverImage: boolean;
  setting: boolean;
  faq: boolean;
  instructor: boolean
}


export interface FindLatestDraftResponse {
  id: number;
  savedAt: string;
  savedAtUTC: string
}


export interface FindMyListByCourseResponse {
  items: ItemResponse[]
}


export interface ItemResponse {
  id: number;
  title: string;
  hasCourse: boolean
}


export interface FindMyListResponse {
  id: number;
  title: string;
  courseCount: number
}


export interface MainInstructor {
  id: number;
  name: string;
  slug?: string
  | null;
  thumbnailUrl: string
}


export interface MissionLectureAttachmentResponse {
  type: ("LINK" | "IMAGE" | "FILE");
  url: string;
  fileId?: number
  | null;
  name?: string
  | null;
  value: string
}


export interface MissionLectureAuthorOneResponse {
  id: number;
  name: string;
  slug?: string
  | null;
  thumbnailUrl: string
}


export interface MissionLectureOneResponse {
  id: number;
  title: string;
  missionId: number;
  body: string;
  attachments: MissionLectureAttachmentResponse[];
  hasAttachment: boolean;
  isMissionStarted: boolean;
  author: MissionLectureAuthorOneResponse;
  mainInstructor: MainInstructor;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface MySubmissionStatusResponse {
  submissionStatus: ("NONE" | "DRAFT" | "REJECTED" | "SUBMITTED" | "ACCEPTED");
  submissionId?: number
  | null
}


export interface MissionLectureAuthor {
  id: number;
  name: string;
  slug?: string
  | null;
  thumbnailUrl: string
}


export interface MissionLectureOneAttachment {
  type: ("LINK" | "IMAGE" | "FILE");
  url?: string
  | null;
  fileId?: number
  | null;
  name?: string
  | null;
  value: string
}


export interface MissionLectureOneByInstructorResponse {
  id: number;
  title: string;
  missionId: number;
  body: string;
  hasAutoFeedback: boolean;
  autoFeedbackBody?: string
  | null;
  attachments: MissionLectureOneAttachment[];
  hasAttachment: boolean;
  author: MissionLectureAuthor;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface GetSummariesByCourseItem {
  missionId: number;
  missionLectureId: number;
  title: string
}


export interface GetSummariesByCourseResponse {
  items: GetSummariesByCourseItem[]
}


export interface CommissionRateResponse {
  agreed: number;
  disagreed: number
}


export interface PagePartnerCourseResponse {
  totalElements?: number
  | null;
  totalPages?: number
  | null;
  size?: number
  | null;
  content?: PartnerCourseResponse[]
  | null;
  number?: number
  | null;
  sort?: SortObject;
  first?: boolean
  | null;
  last?: boolean
  | null;
  numberOfElements?: number
  | null;
  pageable?: PageableObject;
  empty?: boolean
  | null
}


export interface PartnerCourseInfoResponse {
  id: number;
  slug: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  reviewCount: number;
  studentCount: number;
  likeCount: number;
  star: number;
  updatedAt: string;
  publishedAt?: string
  | null;
  updatedAtUTC: string;
  publishedAtUTC?: string
  | null;
  metadata: CourseMetadataResponse;
  abilities: string[];
  targets: string[];
  runtimeSecond: number
}


export interface PartnerCourseInstructorResponse {
  id: number;
  name: string
}


export interface PartnerCoursePriceResponse {
  isDiscount: boolean;
  originalPrice: number;
  payPrice: number;
  regularPrice: number;
  discountRate: number;
  discountEndedAt?: string
  | null;
  discountEndedAtUTC?: string
  | null;
  discountId?: number
  | null;
  discountTitle?: string
  | null
}


export interface PartnerCourseResponse {
  course: PartnerCourseInfoResponse;
  listPrice: PartnerCoursePriceResponse;
  instructor: PartnerCourseInstructorResponse;
  commissionRate: number;
  expectedRevenue: number
}


export interface SearchPartnerCourseResponse {
  page?: PagePartnerCourseResponse;
  partner: SearchPartnerResponse;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: PartnerCourseResponse[]
}


export interface SearchPartnerResponse {
  id: number;
  type: ("BUSINESS" | "PERSONAL");
  commissionRate: CommissionRateResponse;
  hasSettlementInfo: boolean
}


export interface GetMarketingPartnerLinkCreatePreviewResponse {
  canCreate: boolean;
  commissionRate: number;
  attributeWindowDays: number
}


export interface LiveSessionUnit {
  id: number;
  title: string;
  recordingOption: ("PROVIDED" | "NOT_PROVIDED");
  startedAtUTC: string;
  endedAtUTC: string
}


export interface LiveSessionUnitsResponse {
  title: string;
  units: LiveSessionUnit[]
}


export interface GetLiveSessionAttendedResponse {
  isAttended: boolean
}


export interface AttachmentFile {
  id: number;
  name: string
}


export interface GetLiveSessionUnitResponse {
  id: number;
  title: string;
  body: string;
  liveSessionId: number;
  attachment?: AttachmentFile;
  hasAttachment: boolean;
  status: ("NOT_STARTED" | "ON_LIVE" | "ENDED");
  type: ("STANDARD" | "LARGE_SCALE");
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface GetLiveSessionUnitManageResponse {
  id: number;
  title: string;
  body: string;
  recordingOption: ("PROVIDED" | "NOT_PROVIDED");
  attachment?: LiveSessionUnitAttachmentResponse;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface LiveSessionUnitAttachmentResponse {
  id: number;
  name: string
}


export interface LectureAttachmentOneResponse {
  id: number;
  name: string
}


export interface LectureOneResponse {
  title: string;
  body: string;
  isPreview: boolean;
  video?: LectureVideoOneResponse;
  attachment?: LectureAttachmentOneResponse
}


export interface LectureVideoOneResponse {
  id: number;
  name: string
}


export interface GetRecommendedInstructorsResponse {
  items: RecommendedInstructorDto[]
}


export interface RecommendedInstructorDto {
  id: number;
  name: string;
  slug?: string
  | null;
  thumbnail: string
}


export interface AvailableDiscountRange {
  minSupplyPrice: number;
  maxSupplyPrice: number
}


export interface CourseDetailInfo {
  id: number;
  title: string;
  slug: string;
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  vodOriginalLanguage: ("KO" | "EN" | "JA" | "VI" | "CN" | "TW" | "HI" | "FR" | "CA" | "ES" | "MX" | "PT");
  type: ("ON" | "OFF" | "CHALLENGE");
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  price?: number
  | null;
  regularPrice?: number
  | null;
  sourceCurrency: ("KRW" | "USD" | "VND" | "JPY");
  promotionCode: string;
  isPromotion: boolean;
  isExclusive: boolean;
  thumbnailUrl: string;
  reviewCount: number;
  totalStar: number;
  studentCount: number;
  unAnsweredQuestionCount: number;
  discountInfo?: DiscountInfo;
  availableDiscountRange?: AvailableDiscountRange;
  contractStatus?: ("DRAFT" | "NOT_SIGNED" | "CANCELED" | "SIGNED" | "TERMINATED" | "NO_REQUIRED");
  contractType?: ("PLATFORM" | "INFLUENCER" | "OFFLINE" | "E" | "EXCLUSIVE" | "NONEXCLUSIVE");
  publishedAtUTC?: string
  | null;
  instructor: InstructorInfo;
  offlineCourse?: OfflineCourseInfo;
  challengeCourse?: PaginatedCourseByUserChallengeCourseInfo
}


export interface OfflineCourseInfo {
  id: number;
  type: ("CONFERENCE" | "CLASS");
  capacity: number;
  startedAt: string;
  endedAt: string;
  applyStartedAt: string;
  applyEndedAt: string;
  trainingExpenses?: number
  | null;
  isKdt: boolean
}


export interface PaginatedCourseByUserChallengeCourseInfo {
  id: number;
  capacity: number;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  applyStartedAt?: string
  | null;
  applyEndedAt?: string
  | null;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null;
  applyStartedAtUTC?: string
  | null;
  applyEndedAtUTC?: string
  | null
}


export interface PaginatedCourseByUserDetailResponse {
  items: CourseDetailInfo[];
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number
}


export interface GetIsInstructorResponse {
  isInstructor: boolean
}


export interface MainInstructorResponse {
  id: number;
  name: string;
  slug: string;
  introduce: string;
  thumbnail: string;
  isRepresentative: boolean
}


export interface MainInstructorsResponse {
  items: MainInstructorResponse[]
}


export interface ApiResponseFindCouponAvailableCourseForInstructorResponse {
  statusCode: ("OK" | "CREATED" | "BAD_REQUEST" | "NOT_FOUND" | "INTERNAL_SERVER_ERROR" | "FORBIDDEN" | "CONFLICT" | "UNAUTHORIZED" | "PAYLOAD_TOO_LARGE" | "TOO_MANY_REQUESTS");
  message: string;
  errorCode?: string
  | null;
  data: FindCouponAvailableCourseForInstructorResponse
}


export interface CouponAvailableCourseByInstructorDto {
  courseId: number;
  title: string;
  price: number;
  surtaxPrice: number
}


export interface FindCouponAvailableCourseForInstructorResponse {
  items: CouponAvailableCourseByInstructorDto[]
}


export interface GetInstructorByEmailResponse {
  id: number;
  name: string;
  thumbnailImageUrl: string;
  isAdmin: boolean;
  isInstructor: boolean
}


export interface GetCourseInstructorSettingsResponse {
  courseId: number;
  instructors: GetInstructorSettingsItem[];
  whetherAnswer: boolean
}


export interface GetInstructorSettingsItem {
  userId: number;
  sequence: number;
  name: string;
  type: ("MAIN" | "SUB");
  isQuestionEmailAllowed: boolean;
  thumbnailImageUrl: string;
  isRepresentative: boolean
}


export interface GetGiftPhotoCardsResponse {
  items: GiftPhotoCardResponse[]
}


export interface GiftPhotoCardResponse {
  id: number;
  title: string;
  url: string;
  isDefault: boolean
}


export interface FindBestDiscountResponse {
  discountType: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON");
  discountId?: number
  | null;
  discountTitle: string;
  endedAtUTC?: string
  | null;
  paymentPrice: number;
  discountRate: number
}


export interface AttachmentOneResponse {
  name: string
}


export interface CurriculumLectureOneResponse {
  id: number;
  isPreview: boolean;
  isVisible: boolean;
  hasAutoFeedback: boolean;
  sequence: number;
  hasVideo: boolean;
  hasAttachment: boolean;
  title: string;
  type: string;
  video?: VideoOneResponse;
  runtime?: number
  | null;
  attachment?: AttachmentOneResponse;
  attachmentType: ("NONE" | "LINK" | "IMAGE_FILE" | "ATTACHMENT_FILE");
  quizId?: number
  | null;
  isChallengeOnly: boolean;
  missionStartedAtUTC?: string
  | null;
  missionEndedAtUTC?: string
  | null;
  liveSession?: LiveSessionCurriculumResponse
}


export interface CurriculumResponse {
  curriculum: SectionOneResponse[]
}


export interface LiveSessionCurriculumResponse {
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface SectionOneResponse {
  id: number;
  title: string;
  sequence: number;
  isVisible: boolean;
  units: CurriculumLectureOneResponse[]
}


export interface VideoOneResponse {
  name: string
}


export interface CourseSimpleOneResponse {
  id: number;
  title: string;
  type: ("ON" | "OFF" | "CHALLENGE");
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  slug?: string
  | null;
  regularPrice?: number
  | null;
  duration?: number
  | null;
  studentCount: number;
  publishedAt?: string
  | null;
  submittedAt?: string
  | null;
  challengeCourse?: ChallengeCourseResponse;
  submittedAtUTC?: string
  | null;
  publishedAtUTC?: string
  | null
}


export interface CourseVoucherResponse {
  isValid: boolean;
  lastUnitId: number;
  progress: string;
  completeCount: number
}


export interface GetCourseDetailInfoResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  id: number;
  slug?: string
  | null;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  studentCount: number;
  duration?: number
  | null;
  providesCertificate: boolean;
  providesInstructorAnswer: boolean;
  providesInquiry: boolean;
  isLiked: boolean;
  likeCount: number;
  description: string;
  unitSummary: UnitSummaryResponse;
  groupEnrolment?: GroupEnrolmentResponse;
  cart?: CartResponse;
  category: CourseCategoryResponse;
  voucher?: CourseVoucherResponse;
  paymentInfo: CoursePaymentResponse;
  review: ReviewResponse;
  instructors: CourseInstructorResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[];
  publishedAt?: string
  | null;
  lastUpdatedAt?: string
  | null;
  commonTags: CommonTagResponse[];
  isGiftable?: boolean
  | null;
  isRequestGiftable: boolean;
  courseType: ("ON" | "OFF" | "CHALLENGE");
  challenge?: BaseCourseChallengeResponse;
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string
}


export interface DraftCourseCount {
  online: number;
  offline: number;
  challenge: number
}


export interface GetCourseCreationAvailabilityResponse {
  canCreateCourse: boolean;
  draftCourseCount: DraftCourseCount
}


export interface GetChatbotRecommendedCoursesResponse {
  courses: CourseCardItem[]
}


export interface CourseAccessInfoResponse {
  id: number;
  type: ("ON" | "OFF" | "CHALLENGE");
  slug: string;
  enSlug?: string
  | null;
  accessibleMenu: CourseAccessibleMenuResponse
}


export interface CourseAccessibleMenuResponse {
  intro: boolean;
  dashboard: boolean;
  inquiries: boolean;
  community: boolean;
  news: boolean;
  manage: boolean;
  edit: boolean
}


export interface CourseOneLevelResponse {
  level: string;
  levelCode: string
}


export interface CourseOneResponse {
  id: number;
  type: ("ON" | "OFF" | "CHALLENGE");
  title: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  slug: string;
  price?: number
  | null;
  duration?: number
  | null;
  courseType: ("ONLINE" | "CLASS" | "CONFERENCE" | "CHALLENGE");
  skills: CourseSkillOneResponse[];
  representativeInstructor: CourseInstructorResponse;
  category: CourseCategoryTitleResponse;
  thumbnailUrl: string;
  levels: CourseOneLevelResponse[];
  discountedPrice?: number
  | null;
  discountStartedAtUTC?: string
  | null;
  discountEndedAtUTC?: string
  | null;
  instructorCount: number;
  studentCount: number;
  targetPublishAtUTC?: string
  | null;
  submittedAtUTC?: string
  | null
}


export interface StudyProgressResponse {
  totalUnitCount: number;
  isCertificateIssued: boolean;
  isCertificateProvided: boolean;
  completeCount: number;
  progress: string;
  totalCompleteRuntime: number;
  voucherId: number;
  lastUnitId: number
}


export interface RelatedChallengeCourseResponse {
  items: CourseCardItem[]
}


export interface GetOnlineCourseInfoResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  id: number;
  slug: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  studentCount: number;
  duration?: number
  | null;
  providesCertificate: boolean;
  providesInstructorAnswer: boolean;
  providesInquiry: boolean;
  isLiked: boolean;
  likeCount: number;
  description: string;
  unitSummary: UnitSummaryResponse;
  groupEnrolment?: GroupEnrolmentResponse;
  cart?: CartResponse;
  category: CourseCategoryResponse;
  voucher?: CourseVoucherResponse;
  paymentInfo: CoursePaymentResponse;
  review: ReviewResponse;
  instructors: CourseInstructorResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[];
  publishedAt?: string
  | null;
  lastUpdatedAt: string;
  commonTags: CommonTagResponse[];
  isGiftable: boolean;
  isRequestGiftable: boolean;
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string
}


export interface GetOfflineCourseInfoResponse {
  id: number;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  isLiked: boolean;
  likeCount: number;
  providesInquiry: boolean;
  offlineInfo: OfflineCourseResponse;
  category: CourseCategoryResponse;
  voucher?: OfflineCourseVoucherResponse;
  paymentInfo: CoursePaymentResponse;
  instructors: CourseInstructorResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[]
}


export interface KdtResponse {
  trainingExpenses: number
}


export interface OfflineCourseResponse {
  applyStartedAt: string;
  applyEndedAt: string;
  startedAt: string;
  endedAt: string;
  capacity: number;
  applicantCount: number;
  type: ("CONFERENCE" | "CLASS");
  kdt?: KdtResponse;
  survey: SurveyResponse;
  locationType: ("ONLINE" | "OFFLINE");
  onlineMeetingLink?: string
  | null;
  offlineAddressMain?: string
  | null;
  offlineAddressDetail?: string
  | null;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface OfflineCourseVoucherResponse {
  isValid: boolean
}


export interface CourseMetaResponse {
  description: string;
  keywords: string;
  categorySlugs: string[];
  skillSlugs: string[];
  commonTagsSlugs: string[];
  exposure: boolean
}


export interface GetChallengeCourseInfoResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  id: number;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  studentCount: number;
  duration?: number
  | null;
  providesCertificate: boolean;
  providesInstructorAnswer: boolean;
  providesInquiry: boolean;
  isLiked: boolean;
  likeCount: number;
  description: string;
  unitSummary: UnitSummaryResponse;
  groupEnrolment?: GroupEnrolmentResponse;
  cart?: CartResponse;
  category: CourseCategoryResponse;
  voucher?: CourseVoucherResponse;
  paymentInfo: CoursePaymentResponse;
  review: ReviewResponse;
  instructors: CourseInstructorResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[];
  publishedAt?: string
  | null;
  lastUpdatedAt?: string
  | null;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  applyStartedAt?: string
  | null;
  applyEndedAt?: string
  | null;
  capacity: number;
  appliedStudentCount: number;
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string;
  startedAtUTC: string;
  endedAtUTC: string;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string
}


export interface UserProfileCourseResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[]
}


export interface CourseBySkillIdsResponse {
  items: CourseCardItem[];
  attributeToken: string
}


export interface CourseShortCodeResponse {
  items: CourseCardItem[]
}


export interface CourseByLikesResponse {
  items: CourseCardItem[]
}


export interface CourseByInstructorIdResponse {
  items: CourseCardItem[]
}


export interface CourseAutoCompleteResponse {
  items: string[];
  attributionToken: string
}


export interface FindSurveyChoice {
  id: number;
  content: string;
  sequence: number
}


export interface FindSurveyQuestion {
  id: number;
  content: string;
  sequence: number;
  isRequired: boolean;
  isDefaultQuestion: boolean;
  type: ("SUBJECTIVE" | "OBJECTIVE" | "MULTIPLE_OBJECTIVE" | "FILE");
  choices: FindSurveyChoice[]
}


export interface FindSurveyQuestionResponse {
  surveyQuestions: FindSurveyQuestion[]
}


export interface FindSurveyAnswerUploadedFileResponse {
  url: string
}


export interface Choice {
  id: number;
  content: string;
  sequence: number;
  isSelected: boolean
}


export interface FindCourseSurveyByUserCourseResponse {
  id: number;
  title: string;
  challengeCourse: FindCourseSurveyChallengeCourseInfo;
  instructor: InstructorInfo
}


export interface FindCourseSurveyByUserOneResponse {
  questionId: number;
  questionSequence: number;
  questionContent: string;
  isDefault: boolean;
  isRequired: boolean;
  isAnswered: boolean;
  type: ("OBJECTIVE" | "MULTIPLE_OBJECTIVE" | "SUBJECTIVE" | "FILE");
  answerContent?: string
  | null;
  choices: Choice[];
  isFileUploaded: boolean;
  fileName?: string
  | null
}


export interface FindCourseSurveyByUserResponse {
  course: FindCourseSurveyByUserCourseResponse;
  surveyQuestions: FindCourseSurveyByUserOneResponse[]
}


export interface FindCourseSurveyChallengeCourseInfo {
  startedAt: string;
  endedAt: string;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface CourseSkillDto {
  id: number;
  title?: string
  | null;
  subTitle?: string
  | null;
  slug?: string
  | null
}


export interface GetCourseSkillsResponse {
  courseId: number;
  skills: CourseSkillDto[]
}


export interface GetCourseSettingsResponse {
  id: number;
  price?: number
  | null;
  completeMessage?: string
  | null;
  startMessage?: string
  | null;
  whetherAnswer: boolean;
  hasInquiry: boolean;
  questionGuide?: string
  | null;
  duration?: number
  | null;
  exposure: boolean;
  isB2BAvailable: boolean;
  b2bPrice?: number
  | null;
  b2bPriceNextSyncAtUTC?: string
  | null;
  sourceCurrency: ("KRW" | "USD" | "VND" | "JPY")
}


export interface GetChallengeCourseSettingsResponse {
  id: number;
  price?: number
  | null;
  exposure: boolean;
  capacity: number;
  minCapacity: number;
  hasInquiry: boolean;
  whetherAnswer: boolean;
  questionGuide?: string
  | null;
  inquiryEmail?: string
  | null;
  inquiryLink?: string
  | null
}


export interface CourseRecommendationResponse {
  items: CourseCardItem[]
}


export interface FreeCourseRecommendationResponse {
  items: CourseCardItem[]
}


export interface ChallengeCourseBenefitResponse {
  title: string;
  type: string;
  iconType: string;
  isDefault: boolean;
  isSelected: boolean
}


export interface ChallengeCourseBenefitsResponse {
  benefits: ChallengeCourseBenefitResponse[]
}


export interface CourseInfoSkillTagDto {
  id: number;
  subTitle?: string
  | null;
  slug: string;
  relatedCount: number;
  title: string
}


export interface GetCourseInfoResponse {
  id: number;
  abilities: string[];
  based: string[];
  categoryIds: number[];
  mainCategoryId?: number
  | null;
  description: string;
  levelIds: number[];
  /**
   * use skillTags instead
   */
  skillTagIds: number[];
  targets: string[];
  title: string;
  skillTags: CourseInfoSkillTagDto[];
  commonTagIds: number[];
  commonTags: CommonTagResponse[];
  challenge?: ChallengeCourseBenefitsResponse
}


export interface FindOneSentCourseGiftResponse {
  id: number;
  orderId: number;
  orderTitle: string;
  status: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  senderUserId: number;
  senderName: string;
  receiverName: string;
  receiverPhoneNumber?: string
  | null;
  message: string;
  giftPhotoCardId: number;
  giftPhotoCardImageUrl: string;
  code: string;
  refundLimitedAt: string;
  canceledAt?: string
  | null;
  isRefundable: boolean;
  giftSendType: ("PHONE" | "LINK");
  course: FindOneSentCourseInfo;
  paymentInfo: FindOneSentCoursePaymentInfo;
  refundLimitedAtUTC: string;
  canceledAtUTC?: string
  | null
}


export interface FindOneSentCourseInfo {
  id: number;
  title: string;
  slug: string;
  instructor: InstructorInfo
}


export interface FindOneSentCoursePaymentInfo {
  isReceiptAvailable: boolean;
  receiptUrl: string;
  paymentPrice: number;
  paidAt?: string
  | null;
  payMethod?: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "TOSSPAY" | "TOSS_PAY_MONEY" | "SAMSUNGPAY" | "APPLEPAY" | "PAYCO" | "VIRTUAL_ACCOUNT" | "BANK_TRANSFER" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "VBANK" | "CARD_LEGACY" | "NAVERPAY_LEGACY" | "POINT" | "PHONE" | "EMPTY" | "NONE" | "FPX" | "SOFORT" | "PAYNOW" | "GRABPAYPH" | "GRABPAYMY" | "BOOST" | "TOUCHNGO" | "KONBINI" | "PAYSHOP" | "BANCONTACT" | "EPS" | "MULTIBANCO" | "PRZELEWY24" | "BLIK" | "IDEAL" | "PLATFORM" | "POLI" | "INSTANT_BANK_TRANSFER" | "UPI");
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  pg?: ("KAKAOPAY" | "NAVERPAY" | "TOSS_WIDGET" | "TOSS" | "TOSS_V2" | "TOSS_GLOBAL" | "TOSS_PAY_LEGACY" | "TOSS_PAY" | "IMP_KAKAOPAY" | "IMP_NAVERPAY" | "IMP_NICE" | "IMP_JTNET" | "PORTONE");
  discountInfo?: DiscountInfo;
  paidAtUTC?: string
  | null
}


export interface FindSentCourseGiftItem {
  id: number;
  receiptUrl: string;
  status: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  createdAt: string;
  orderTitle: string;
  courseTitle: string;
  courseSlug: string;
  receiverName: string;
  isDeletedCourse: boolean;
  isRefundable: boolean;
  refundLimitedAt: string;
  regularPrice: number;
  paymentPrice: number;
  currency: ("KRW" | "USD" | "VND" | "JPY");
  timezone: string;
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  isReceiptAvailable: boolean;
  isInvoiceAvailable: boolean;
  createdAtUTC: string;
  refundLimitedAtUTC?: string
  | null
}


export interface FindSentCourseGiftResponse {
  items: FindSentCourseGiftItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPage: number
}


export interface FindReceivedCourseGiftItem {
  id: number;
  code: string;
  giftStatus?: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  giftPhotoCardId: number;
  giftPhotoCardImageUrl: string;
  createdAt: string;
  orderTitle: string;
  courseTitle: string;
  courseSlug: string;
  isDeletedCourse: boolean;
  senderName: string;
  limitedAt?: string
  | null;
  canceledAt?: string
  | null;
  approvedAt: string;
  duration?: number
  | null;
  createdAtUTC: string;
  limitedAtUTC?: string
  | null;
  approvedAtUTC: string;
  canceledAtUTC?: string
  | null;
  isCanceled: boolean;
  status: ("RECEIVED" | "CANCELED")
}


export interface FindReceivedCourseGiftResponse {
  items: FindReceivedCourseGiftItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPage: number
}


export interface BuyerInfo {
  name: string;
  phone: string;
  email: string;
  countryCode: string
}


export interface CourseGiftItem {
  id: number;
  giftStatus?: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  message: string;
  giftPhotoCardId: number;
  giftPhotoCardImageUrl: string;
  code: string;
  giftSendType: ("PHONE" | "LINK");
  receiver: CourseGiftOrderCompleteReceiver;
  status: ("READY_TO_RECEIVE" | "RECEIVED" | "CANCELED")
}


export interface CourseGiftOrderCompleteReceiver {
  name: string;
  phoneNumber?: string
  | null
}


export interface CourseGiftOrderCompleteResponse {
  id: number;
  title: string;
  refundLimitedAt: string;
  canceledAt?: string
  | null;
  courseGift: CourseGiftItem;
  course: CourseGiftOrderCourseItem;
  mainInstructor: MainInstructor;
  paymentInfo: CourseGiftPaymentInfo;
  refundLimitedAtUTC: string;
  canceledAtUTC?: string
  | null
}


export interface CourseGiftOrderCourseItem {
  id: number;
  title: string;
  slug: string
}


export interface CourseGiftPaymentInfo {
  isReceiptAvailable: boolean;
  receiptUrl: string;
  paymentPrice: number;
  paidAt: string;
  payMethod: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "TOSSPAY" | "TOSS_PAY_MONEY" | "SAMSUNGPAY" | "APPLEPAY" | "PAYCO" | "VIRTUAL_ACCOUNT" | "BANK_TRANSFER" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "VBANK" | "CARD_LEGACY" | "NAVERPAY_LEGACY" | "POINT" | "PHONE" | "EMPTY" | "NONE" | "FPX" | "SOFORT" | "PAYNOW" | "GRABPAYPH" | "GRABPAYMY" | "BOOST" | "TOUCHNGO" | "KONBINI" | "PAYSHOP" | "BANCONTACT" | "EPS" | "MULTIBANCO" | "PRZELEWY24" | "BLIK" | "IDEAL" | "PLATFORM" | "POLI" | "INSTANT_BANK_TRANSFER" | "UPI");
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  pg?: ("KAKAOPAY" | "NAVERPAY" | "TOSS_WIDGET" | "TOSS" | "TOSS_V2" | "TOSS_GLOBAL" | "TOSS_PAY_LEGACY" | "TOSS_PAY" | "IMP_KAKAOPAY" | "IMP_NAVERPAY" | "IMP_NICE" | "IMP_JTNET" | "PORTONE");
  priceBreakdown: PriceBreakdown;
  buyer: BuyerInfo;
  paidAtUTC: string
}


export interface Discount {
  id?: number
  | null;
  title: string;
  rate: number;
  amount: number
}


export interface PriceBreakdown {
  coursePrice: number;
  regularPrice: number;
  sellingPrice: number;
  discount?: Discount
}


export interface FindOneCourseGiftCourseInfo {
  id: number;
  title: string;
  slug: string;
  coverFileUrl: string;
  duration?: number
  | null;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  isDeleted: boolean;
  mainInstructor: MainInstructorInfo
}


export interface FindOneCourseGiftResponse {
  id: number;
  orderTitle: string;
  status: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  senderName: string;
  message: string;
  sendType: ("PHONE" | "LINK");
  approvedAt?: string
  | null;
  approvedLimitedAt: string;
  canceledAt?: string
  | null;
  isApproveAvailable: boolean;
  alreadyHasVoucher: boolean;
  isMyReceived: boolean;
  receivedUserId?: number
  | null;
  giftPhotoCard: GiftPhotoCardInfo;
  loginUser?: LoginUser;
  course: FindOneCourseGiftCourseInfo;
  courseGiftVoucher?: FindOneCourseGiftVoucherInfo;
  approvedAtUTC?: string
  | null;
  approvedLimitedAtUTC: string;
  canceledAtUTC?: string
  | null
}


export interface FindOneCourseGiftVoucherInfo {
  id: number;
  limitedAt?: string
  | null;
  limitedAtUTC?: string
  | null
}


export interface GiftPhotoCardInfo {
  id: number;
  url: string
}


export interface LoginUser {
  name: string;
  email: string;
  isBlocked: boolean
}


export interface MainInstructorInfo {
  userId: number;
  name: string
}


export interface GetCourseFaqResponse {
  id: number;
  title: string;
  body: string
}


export interface GetCourseFaqsResponse {
  hasFaq?: boolean
  | null;
  items: GetCourseFaqResponse[]
}


export interface GetCourseCoverVodResponse {
  url?: string
  | null;
  id?: number
  | null;
  fileName?: string
  | null;
  metadata?: CourseVideoMetadata
}


export interface GetCourseCoverImageResponse {
  url: string;
  id?: number
  | null;
  metadata?: CourseCoverMetadata
}


export interface GetCourseCoverAiGenerationRetryInfoResponse {
  retryable: boolean;
  availableRetryCount: number
}


export interface GetCourseCoverAiGenerationHistoriesResponse {
  items: HistoryItem[]
}


export interface HistoryItem {
  id: number;
  requestedAt: string;
  completedAt: string;
  templateId: number;
  templateTitle: string;
  compositeImageFileName?: string
  | null;
  compositeImageUrl?: string
  | null;
  images: ImageItem[]
}


export interface ImageItem {
  id?: number
  | null;
  url?: string
  | null;
  isDisliked: boolean
}


export interface GetCourseCoverAiGenerationLatestHistoryResponse {
  id?: number
  | null;
  status: ("NONE" | "NOT_REQUESTED" | "IN_PROGRESS" | "COMPLETED" | "FAILED")
}


export interface CourseCoverAiGenerationTemplateItem {
  id: number;
  title: string;
  description: string;
  requiredImageType: ("NONE" | "PERSON");
  thumbnailUrl: string;
  templateKey: string;
  exampleImageItems: ExampleImageItem[]
}


export interface ExampleImageItem {
  url: string
}


export interface GetCourseCoverAiGenerationTemplatesResponse {
  items: CourseCoverAiGenerationTemplateItem[]
}


export interface ContractInfo {
  current?: CurrentContract;
  defaults: DefaultContractResponse[]
}


export interface CurrentContract {
  contractType: ("PLATFORM" | "INFLUENCER" | "OFFLINE" | "E" | "EXCLUSIVE" | "NONEXCLUSIVE");
  isExclusive: boolean;
  isPromotion: boolean;
  isInflearnMarketing: boolean;
  inflearnMarketingConfirmedAt?: string
  | null;
  rate: RateInfo;
  inflearnMarketingConfirmedAtUTC?: string
  | null
}


export interface DefaultContractResponse {
  contractType: ("PLATFORM" | "INFLUENCER" | "OFFLINE" | "E" | "EXCLUSIVE" | "NONEXCLUSIVE");
  isPromotion?: boolean
  | null;
  isExclusive?: boolean
  | null;
  rate: RateInfo
}


export interface GetCourseContractCourseInfo {
  id: number;
  title: string;
  price?: number
  | null;
  isB2bAvailable: boolean;
  allowedUsageAi?: boolean
  | null;
  isB2bSubscription: boolean
}


export interface GetCourseContractResponse {
  course: GetCourseContractCourseInfo;
  contract: ContractInfo
}


export interface RateInfo {
  baseRate?: number
  | null;
  b2bRate?: number
  | null;
  promotionLinkRate?: number
  | null;
  openingMonthRate?: number
  | null;
  instructorCouponRate?: number
  | null;
  inflearnMarketingRate?: number
  | null;
  additionalMarketingRate?: number
  | null
}


export interface ApiResponseGetInflearnMarketingContentTermResponse {
  statusCode: ("OK" | "CREATED" | "BAD_REQUEST" | "NOT_FOUND" | "INTERNAL_SERVER_ERROR" | "FORBIDDEN" | "CONFLICT" | "UNAUTHORIZED" | "PAYLOAD_TOO_LARGE" | "TOO_MANY_REQUESTS");
  message: string;
  errorCode?: string
  | null;
  data: GetInflearnMarketingContentTermResponse
}


export interface GetInflearnMarketingContentTermResponse {
  content: string
}


export interface GetCourseContractContentTermResponse {
  term: string;
  termType: ("NEW_CONTRACT" | "MODIFICATION_CONTRACT");
  courseType: ("ON" | "OFF" | "CHALLENGE")
}


export interface ApiResponseFindInflearnMarketingConfirmRequiredCoursesResponse {
  statusCode: ("OK" | "CREATED" | "BAD_REQUEST" | "NOT_FOUND" | "INTERNAL_SERVER_ERROR" | "FORBIDDEN" | "CONFLICT" | "UNAUTHORIZED" | "PAYLOAD_TOO_LARGE" | "TOO_MANY_REQUESTS");
  message: string;
  errorCode?: string
  | null;
  data: FindInflearnMarketingConfirmRequiredCoursesResponse
}


export interface FindInflearnMarketingConfirmRequiredCoursesResponse {
  items: InflearnMarketingConfirmRequiredItem[]
}


export interface InflearnMarketingConfirmRequiredItem {
  id: number;
  title: string
}


export interface FindCourseContentResponse {
  jsonBody: string;
  courseOriginalLanguage: ("KO" | "EN" | "JA" | "VI")
}


export interface FindCourseContentTemplateResponse {
  id: number;
  title: string;
  authorType: ("INFLAB" | "INSTRUCTOR");
  htmlBody: string;
  jsonBody: string;
  createdAt: string;
  thumbnailUrl?: string
  | null;
  createdAtUTC: string
}


export interface OffsetPageResponseFindCourseContentTemplateResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: FindCourseContentTemplateResponse[]
}


export interface CourseContentHistoryOrigin {
  id: number;
  name: string;
  savedAt: string;
  type: string;
  userName: string;
  userId: number;
  savedAtUTC: string
}


export interface FindCourseContentHistoryResponse {
  id: number;
  name: string;
  savedAt: string;
  type: string;
  userName: string;
  userId: number;
  origin?: CourseContentHistoryOrigin;
  savedAtUTC: string
}


export interface FindOneCourseContentHistoryResponse {
  id: number;
  name: string;
  savedAt: string;
  userName: string;
  type: string;
  jsonBody: string;
  savedAtUTC: string
}


export interface GetLatestCourseContentGenerationHistoryResponse {
  id?: number
  | null;
  templateId?: number
  | null;
  jsonBody?: string
  | null;
  status: ("NONE" | "NOT_REQUESTED" | "COMPLETED" | "FAILED")
}


export interface CourseContentGenerationTemplateItem {
  id: number;
  title: string;
  description: string;
  requiredInfoType: ("NONE" | "INSTRUCTOR_PROFILE");
  templateKey: ("PROBLEM" | "RESULT" | "STORY");
  blocks: TemplateItemComponentBlock[]
}


export interface GetCourseContentGenerationTemplatesResponse {
  items: CourseContentGenerationTemplateItem[]
}


export interface TemplateItemComponentBlock {
  title: string;
  type: ("NORMAL" | "HOOKING")
}


export interface GetCertificatesResponse {
  userId: number;
  voucherId: number;
  courseId: number;
  courseSlug: string;
  courseTitle: string;
  courseType: ("ON" | "OFF" | "CHALLENGE");
  courseThumbnailUrl: string;
  certificateConfirmedAt?: string
  | null;
  certificatedAt?: string
  | null;
  certificateConfirmedAtUTC?: string
  | null;
  certificatedAtUTC?: string
  | null
}


export interface UnconfirmedResponse {
  hasUnconfirmedCertificate: boolean
}


export interface GetCertificateDetailResponse {
  userId: number;
  courseId: number;
  voucherId: number;
  realName: string;
  title: string;
  runtime: number;
  instructorName: string;
  startedAt: string;
  certificatedAt: string;
  startedAtUTC: string;
  certificatedAtUTC: string
}


export interface CouponDiscountResponse {
  type: ("PERCENT" | "PRICE");
  value: number
}


export interface CouponItem {
  couponId: number;
  couponUserId: number;
  title: string;
  discount: CouponDiscountResponse;
  target: CouponTargetResponse;
  endedAt: string;
  canResurrect: boolean;
  isAvailable: boolean;
  endedAtUTC: string
}


export interface CouponTargetResponse {
  type: ("ALL" | "COURSE" | "ROADMAP");
  courseIds: number[];
  requiredCourseIds?: number[]
  | null;
  roadmap?: RaodmapWithProgress
}


export interface GetCouponsResponse {
  items: CouponItem[]
}


export interface RaodmapWithProgress {
  id: number;
  title: string;
  progress: number;
  enrolledCount: number;
  likeCount: number;
  commentCount: number;
  items: RoadmapItemSummary[]
}


export interface RoadmapCourse {
  id: number
}


export interface RoadmapItemSummary {
  id: number;
  title: string;
  type: ("COURSE" | "BOOK" | "LINK");
  course?: RoadmapCourse
}


export interface CourseSkillResponse {
  id: number;
  title: string;
  slug: string
}


export interface DiscountDto {
  id?: number
  | null;
  title: string;
  discountStrategy: ("PERCENT" | "PRICE");
  type: ("COURSE" | "USER" | "PLATFORM" | "NONE" | "COUPON");
  endedAt: string;
  discountRate: number;
  discountPrice: number;
  endedAtUTC: string
}


export interface FindCouponTargetsResponse {
  items: CouponTargetResponse[];
  nextCursor?: string
  | null;
  hasNext: boolean;
  pageSize: number
}


export interface GetCouponIssuableResponse {
  canIssueCoupon: boolean;
  coupon: IssuableCouponResponse
}


export interface IssuableCouponResponse {
  id: number;
  discountType: ("PERCENT" | "PRICE");
  discountValue: number
}


export interface FindCommonTagResponse {
  items: FindCommonTagResponseItem[];
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number
}


export interface FindCommonTagResponseItem {
  id: number;
  title: string;
  subTitle: string;
  slug: string;
  relatedCount: number
}


export interface FindRecommendCommonTagResponse {
  items: FindCommonTagResponseItem[]
}


export interface LegacyChallengeBySkillResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[]
}


export interface ChallengeStepStatusResponse {
  info: boolean;
  curriculum: boolean;
  detail: boolean;
  coverImage: boolean;
  survey: boolean;
  setting: boolean;
  autoMessage: boolean;
  faq: boolean;
  instructor: boolean
}


export interface ChallengeScheduleLiveSessionPeriodResponse {
  id: number;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface GetChallengeSchedulesResponse {
  applyPeriod?: Period;
  challengePeriod?: Period;
  liveSessions: ChallengeScheduleLiveSessionPeriodResponse[];
  applyStartedAtUTC?: string
  | null;
  applyEndedAtUTC?: string
  | null;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null
}


export interface CategoryDto {
  id: number;
  slug: string;
  title: string
}


export interface GetOnlineCourseResponse {
  id: number;
  slug: string;
  thumbnailUrl: string;
  title: string;
  totalStar: number;
  reviewCount: number;
  studentCount: number;
  representativeCategory: CategoryDto;
  mainCategories: CategoryDto[];
  subCategories: CategoryDto[];
  skillTags: CategoryDto[]
}


export interface GetUnownedCompletedChallengesResponse {
  items: UnownedCompletedChallenge[]
}


export interface UnownedCompletedChallenge {
  id: number;
  title: string;
  thumbnailUrl: string;
  applicantCount: number
}


export interface GetChallengeUsedSkillTagsResponse {
  items: UsedSkillTagItem[]
}


export interface UsedSkillTagItem {
  id: number;
  slug: string
}


export interface LegacyChallengeCourseRecommendResponse {
  attributionToken: string;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[]
}


export interface FreeLiveChallenge {
  id: number;
  thumbnailUrl?: string
  | null;
  title: string;
  slug: string;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  liveSessionStartedAtUTC?: string
  | null;
  liveSessionEndedAtUTC?: string
  | null;
  isAlreadyApplied: boolean;
  canApply: boolean;
  instructor: InstructorInfo;
  representativeCategory: CategoryInfo;
  isAlreadySubscribed: boolean
}


export interface FreeLiveChallengeResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: FreeLiveChallenge[]
}


export interface GetFeaturedChallengesResponse {
  items: FeaturedChallenge[]
}


export interface EndedChallenge {
  id: number;
  thumbnailUrl?: string
  | null;
  title: string;
  slug: string;
  description?: string
  | null;
  instructor: InstructorInfo;
  representativeCategory: CategoryInfo;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  price: number;
  regularPrice: number;
  payPrice: number;
  discountRate?: number
  | null;
  isFree: boolean;
  isDiscounting: boolean;
  hasLiveSession: boolean;
  /**
   * use applyClosedAtUTC
   */
  isApplyEnded: boolean;
  challengeStatus: ("BEFORE_APPLY" | "APPLYING" | "AFTER_APPLY" | "PROCESSING" | "PARTICIPATING" | "COMPLETED");
  capacity: number;
  applicantCount: number;
  displayRemainingApplicantCount?: number
  | null;
  isAlreadySubscribed: boolean;
  applyClosedAt?: string
  | null;
  applyClosedAtUTC?: string
  | null;
  applicantRate: number
}


export interface GetEndedChallengeCourseResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: EndedChallenge[]
}


export interface CustomIconResponse {
  iconType: string
}


export interface GetCustomIconsResponse {
  icons: CustomIconResponse[]
}


export interface ChallengeSubscriptionItem {
  id: number;
  type: ("CHALLENGE_APPLY_STARTED" | "NEW_CHALLENGE_OPENED")
}


export interface GetChallengeNotificationSubscriptionsResponse {
  items: ChallengeSubscriptionItem[]
}


export interface ParentCategory {
  id: number;
  title: string;
  slug: string
}


export interface SearchCategoryDto {
  id: number;
  title: string;
  slug: string;
  parent?: ParentCategory
}


export interface SearchCategoryResponse {
  items: SearchCategoryDto[]
}


export interface FindAllCategoriesResponse {
  categories: ParentCategoryWithChildrenDto[]
}


export interface ParentCategoryWithChildrenDto {
  id: number;
  slug: string;
  title: string;
  originalTitle: string;
  icon: string;
  subCategories: ChildCategoryDto[]
}


export interface ChallengeCartResponse {
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  applyStartedAt?: string
  | null;
  startedAtUTC: string;
  endedAtUTC: string;
  applyStartedAtUTC: string
}


export interface ClientCartItemDto {
  id: number;
  courseId: number;
  slug: string;
  title: string;
  duration?: number
  | null;
  thumbnailUrl: string;
  regularPrice: number;
  paymentPrice: number;
  krwRegularPrice: number;
  krwPaymentPrice: number;
  usdRegularPrice: number;
  usdPaymentPrice: number;
  publishedAt?: string
  | null;
  updatedAt?: string
  | null;
  discount?: DiscountDto;
  isPromotion: boolean;
  type: ("ON" | "OFF" | "CHALLENGE");
  studentCount: number;
  reviewCount: number;
  reviewAverage: number;
  likeCount: number;
  level?: CourseLevelResponse;
  categories: FindClientCartCourseCategoryResponse[];
  skills: CourseSkillResponse[];
  instructorId: number;
  instructorName: string;
  kdtPrice?: number
  | null;
  currency: {
    currencyCode?: string
    | null;
    displayName?: string
    | null;
    symbol?: string
    | null;
    defaultFractionDigits?: number
    | null;
    numericCode?: number
    | null;
    numericCodeAsString?: string
    | null
  };
  challenge?: ChallengeCartResponse;
  publishedAtUTC: string;
  updatedAtUTC: string
}


export interface FindClientCartCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: ParentCategoryResponse
}


export interface FindClientCartResponse {
  items: ClientCartItemDto[];
  now: string;
  nowUTC: string
}


export interface BuyerInfoResponse {
  email?: string
  | null;
  phoneNumber?: string
  | null;
  name?: string
  | null;
  countryCode?: string
  | null;
  useGlobalCard: boolean;
  country: string
}


export interface AdpickCourse {
  goodsNo: string;
  goodsNm: string;
  goodsPriceOrg: number;
  goodsPrice: number;
  link: string;
  imageUrl: string;
  reviewCnt: number;
  commission: number
}


export interface AdpickCourseResponse {
  total_rows: number;
  current_page: number;
  list: AdpickCourse[]
}


export interface MarketingDisagreedCourse {
  p_cd: string;
  commission: number
}


export interface CourseDetailDiscountResponse {
  title: string;
  discountedPrice: number;
  startedAt: string;
  endedAt: string;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface GetCourseDetailCourseCategoryResponse {
  id: number;
  title: string;
  parent: ParentCategoryResponse
}


export interface GetCourseDetailResponse {
  id: number;
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  type: ("ON" | "OFF" | "CHALLENGE");
  courseType: ("ONLINE" | "CLASS" | "CONFERENCE" | "CHALLENGE");
  title: string;
  slug: string;
  thumbnailUrl: string;
  textBody: string;
  abilities: string[];
  allowedUsageAi: boolean;
  description?: string
  | null;
  keywords?: string
  | null;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  publishedAt?: string
  | null;
  exposure: boolean;
  courseTags: CourseTagResponse[];
  price: number;
  regularPrice: number;
  discount?: CourseDetailDiscountResponse;
  revenueRatio: number;
  totalSequence: number;
  popularSequence: number;
  likeCount: number;
  isPromotion: boolean;
  isB2bSubscription: boolean;
  categories: GetCourseDetailCourseCategoryResponse[];
  skills: CourseSkillResponse[];
  levels: CourseLevelResponse[];
  ratings: RatingResponse;
  mainInstructors: InstructorResponse[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string
  | null;
  publishedAtUTC?: string
  | null;
  createdAtUTC: string;
  updatedAtUTC: string;
  deletedAtUTC?: string
  | null
}


export interface RatingHistogramResponse {
  one: number;
  two: number;
  three: number;
  four: number;
  five: number
}


export interface RatingResponse {
  totalCount: number;
  average: number;
  histogram: RatingHistogramResponse
}


export interface CartItemCourseResponse {
  id: number;
  title: string;
  type: ("ON" | "OFF" | "CHALLENGE");
  price: number;
  regularPrice: number
}


export interface CartItemDiscountResponse {
  isDiscounting: boolean;
  discountedPrice: number;
  regularPrice: number;
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface CartItemResponse {
  course: CartItemCourseResponse;
  discount?: CartItemDiscountResponse
}


export interface FindCartItemsResponse {
  items: CartItemResponse[]
}


export interface GetVoucherResponse {
  id: number;
  groupId?: number
  | null;
  progress: string;
  createdAt: string;
  endedAt?: string
  | null
}


export interface CompleteUnit {
  id: number;
  title: string;
  hasVideo: boolean;
  vodId?: string
  | null
}


export interface GetRecentLearningsResponse {
  user: UserInfo;
  recentLearnings: RecentLearningItem[]
}


export interface RecentLearningItem {
  progress: string;
  accessedAt?: string
  | null;
  accessedAtUTC?: string
  | null;
  courseId: number;
  courseTitle: string;
  childCategories: string[];
  lectureCount: number;
  completeCount: number;
  completeUnits: CompleteUnit[]
}


export interface UserInfo {
  id: number;
  name: string
}


export interface VoucherCourseResponse {
  id: number;
  courseId: number;
  unitId?: number
  | null;
  userId: number;
  groupCode?: string
  | null;
  progress: string;
  completeCount: number;
  limitedAt?: string
  | null;
  createdAt: string;
  accessedAt?: string
  | null;
  startedAt?: string
  | null;
  completedAt?: string
  | null;
  payPrice: number;
  courseTitle: string;
  courseDescription?: string
  | null;
  courseDuration?: number
  | null;
  regularPrice: number;
  limitedAtUTC?: string
  | null;
  createdAtUTC: string;
  accessedAtUTC?: string
  | null;
  startedAtUTC?: string
  | null;
  completedAtUTC?: string
  | null
}


export interface InternalCourseChallengeResponse {
  page?: PageCourseChallengeItemResponse;
  instructorCount: number;
  adminCount: number;
  allCount: number;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseChallengeItemResponse[]
}


export interface CompletedVoucher {
  id: number;
  courseId: number
}


export interface FindCompletedVoucherResponse {
  vouchers: CompletedVoucher[]
}


export interface UnitTranslationItemResponse {
  id: number;
  courseId: number;
  language: ("KO" | "EN" | "JA" | "VI");
  title: string;
  body: string
}


export interface UnitTranslationResponse {
  items: UnitTranslationItemResponse[]
}


export interface GetUserOfUnansweredSurveyResponse {
  items: UserOfUnansweredSurveyDto[]
}


export interface UserOfUnansweredSurveyDto {
  userId: number;
  courseId: number;
  title: string;
  createdAt: string
}


export interface FindRemainSettlementAmountResponse {
  amount: number
}


export interface CourseQuizByAdminQuestion {
  id: number;
  title: string;
  explanation: string;
  answerContent: string;
  sequence: number
}


export interface CourseQuizByAdminResponse {
  courseId: number;
  courseTitle: string;
  mainInstructorName?: string
  | null;
  quizzes: QuizItem[]
}


export interface QuizItem {
  id: number;
  quizLectureTitle: string;
  quizQuestions: CourseQuizByAdminQuestion[]
}


export interface QuizFindByAdminItem {
  id: number;
  courseId?: number
  | null;
  quizLectureId?: number
  | null;
  mainInstructorUserId?: number
  | null;
  quizLectureTitle?: string
  | null;
  createdAt: string
}


export interface QuizFindByAdminResponse {
  items: QuizFindByAdminItem[];
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number
}


export interface QuizQuestionFindByAdminChoice {
  id: number;
  content: string;
  isAnswer: boolean;
  sequence: number
}


export interface QuizQuestionFindByAdminQuestion {
  id: number;
  sequence: number;
  choices: QuizQuestionFindByAdminChoice[];
  title: string;
  explanation: string
}


export interface QuizQuestionFindByAdminResponse {
  quizQuestions: QuizQuestionFindByAdminQuestion[];
  courseTitle?: string
  | null;
  quizLectureTitle?: string
  | null;
  quizLectureId?: number
  | null
}


export interface GetOnePromotionCardResponse {
  id: number;
  title: string;
  type: ("COURSE" | "URL");
  course?: PromotionCardCourse;
  url?: string
  | null;
  tagTitle: string;
  sequence: number;
  imageId?: number
  | null;
  imageUrl?: string
  | null;
  bannerImageId?: number
  | null;
  bannerImageUrl?: string
  | null;
  bannerMobileImageId?: number
  | null;
  bannerMobileImageUrl?: string
  | null;
  bannerTitle?: string
  | null;
  isDDayActive: boolean;
  altText?: string
  | null;
  activeStatus: ("ACTIVE" | "INACTIVE");
  startedAt: string;
  endedAt?: string
  | null;
  categoryIds: number[];
  keywords: string[];
  isExpose: boolean;
  startedAtUTC: string;
  endedAtUTC?: string
  | null
}


export interface GetPromotionCardListResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: GetOnePromotionCardResponse[]
}


export interface PromotionCardCourse {
  id: number;
  title: string;
  slug: string
}


export interface FindActivePlatformDiscountResponse {
  discount?: PlatformDiscountResponse
}


export interface PlatformDiscountResponse {
  id: number;
  title: string;
  value: number;
  startedAtUTC: string;
  endedAtUTC: string
}


export interface FindOrderItemResponse {
  id: number;
  regularPrice: number;
  paymentPrice: number;
  createdAt: string;
  title: string
}


export interface GetMyRoadmapResponse {
  id: number;
  status: ("DRAFT" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PRIVATE");
  title: string;
  thumbnail?: Thumbnail;
  jsonDescription: string;
  htmlDescription: string;
  courses: RoadmapCourseDto[];
  latestPublishedHistory?: PublishedHistory
}


export interface RoadmapCourseDto {
  id: number;
  title: string;
  thumbnailUrl: string;
  defaultDescription: string;
  instructorName: string;
  description?: string
  | null
}


export interface FindMissionByAdminItem {
  missionId: number;
  missionTitle: string;
  courseTitle: string;
  courseId: number;
  courseSlug: string;
  unitId: number;
  instructorUserId: number;
  attachmentType: ("LINK" | "IMAGE" | "FILE" | "NONE");
  link?: string
  | null;
  imageFileId?: number
  | null;
  attachmentFileId?: number
  | null
}


export interface FindMissionByAdminResponse {
  items: FindMissionByAdminItem[];
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number
}


export interface MentoringOrderResponse {
  id: number;
  title: string;
  regularPrice: number;
  paymentPrice: number;
  status: ("CANCEL_DELETE" | "MENTEE_CANCEL" | "PARTIAL_CANCEL" | "CANCEL_NOT_ENOUGH_PROGRESS" | "GROUP_PAYMENT_CANCEL" | "PAYMENT_CANCEL" | "ORDER_FORM" | "CONFLICT_CANCEL" | "AUTO_CANCEL" | "PAYMENT_READY" | "TOTAL_CANCEL" | "PAYMENT_FAIL" | "PAYMENT_STOP" | "CODE_ORDER" | "ORDER_CANCEL" | "PAYMENT_COMPLETE" | "PAYMENT_COMPLETE_PROCESSING" | "ADMIN_CANCEL" | "MENTOR_CANCEL" | "DEPOSIT_WAIT" | "WC_COMPLETED" | "MANUAL_DELETE" | "REFUND_REQUEST");
  paymentChannel: ("TOSS" | "PAYMENTWALL" | "TAZAPAY" | "PAYPAL" | "PAYLETTER" | "IAMPORT" | "NAVERPAY" | "NONE" | "TOSS_PAY");
  paymentMethod: ("CARD" | "NAVERPAY" | "NAVERPAY_MONEY" | "KAKAOPAY" | "TOSSPAY" | "TOSS_PAY_MONEY" | "SAMSUNGPAY" | "APPLEPAY" | "PAYCO" | "VIRTUAL_ACCOUNT" | "BANK_TRANSFER" | "LIFE_EDUCATION" | "OVERSEAS" | "INFPAY" | "VBANK" | "CARD_LEGACY" | "NAVERPAY_LEGACY" | "POINT" | "PHONE" | "EMPTY" | "NONE" | "FPX" | "SOFORT" | "PAYNOW" | "GRABPAYPH" | "GRABPAYMY" | "BOOST" | "TOUCHNGO" | "KONBINI" | "PAYSHOP" | "BANCONTACT" | "EPS" | "MULTIBANCO" | "PRZELEWY24" | "BLIK" | "IDEAL" | "PLATFORM" | "POLI" | "INSTANT_BANK_TRANSFER" | "UPI");
  paidAtUTC?: string
  | null;
  receiptUrl?: string
  | null
}


export interface FindMarketingPartnerResponse {
  page?: PageMarketingPartnerItem;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MarketingPartnerItem[]
}


export interface MarketingPartnerItem {
  user: MarketingPartnerUser;
  marketing: MarketingPartnerMarketing
}


export interface MarketingPartnerMarketing {
  commissionRate: CommissionRate;
  reservedCommissionRate?: ReservedCommissionRate;
  attributionWindow: number;
  items: unknown[];
  activityLinks: string[];
  type: ("BUSINESS" | "PERSONAL");
  status: ("PENDING" | "APPROVED")
}


export interface MarketingPartnerUser {
  id: number;
  email: string;
  nickname: string;
  realName: string;
  createdAt: string;
  accessedAt?: string
  | null
}


export interface PageMarketingPartnerItem {
  totalElements?: number
  | null;
  totalPages?: number
  | null;
  size?: number
  | null;
  content?: MarketingPartnerItem[]
  | null;
  number?: number
  | null;
  sort?: SortObject;
  first?: boolean
  | null;
  last?: boolean
  | null;
  numberOfElements?: number
  | null;
  pageable?: PageableObject;
  empty?: boolean
  | null
}


export interface ReservedCommissionRate {
  agreed?: number
  | null;
  disagreed?: number
  | null;
  startedAt?: string
  | null
}


export interface GetMarketingPartnerHistoriesResponse {
  items: MarketingPartnerHistoryItem[]
}


export interface MarketingPartnerHistoryItem {
  updater: Updater;
  startedAt: string;
  updatedAt: string;
  commissionRate: CommissionRate;
  attributionWindow: number
}


export interface Updater {
  userId?: number
  | null;
  name?: string
  | null
}


export interface CourseByUserDetailResponse {
  items: CourseDetailInfo[]
}


export interface FindInstitutionResponse {
  id: number;
  title: string;
  iconUrl?: string
  | null
}


export interface OffsetPageResponseGetVouchersResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: GetVouchersResponse[]
}


export interface Curriculum {
  sectionId: number;
  title: string;
  units: Unit[]
}


export interface FindLearningStatusResponse {
  courseId: number;
  courseTitle: string;
  curriculum: Curriculum[]
}


export interface Unit {
  id: number;
  title: string;
  runtime: number;
  completedAt?: string
  | null
}


export interface GetCourseItemResponse {
  id: number;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  title: string;
  type: ("ON" | "OFF" | "CHALLENGE");
  based: string[];
  abilities: string[];
  targets: string[];
  description: string;
  exposure: boolean;
  runtime: number;
  totalStar: number;
  reviewCnt: number;
  studentCnt: number;
  slug: string;
  url: string;
  instructorName: string;
  thumbnailUrl: string;
  publishedAt?: string
  | null;
  lastUpdatedAt?: string
  | null;
  publishedAtUTC?: string
  | null;
  lastUpdatedAtUTC: string
}


export interface GetCoursesResponse {
  courses: GetCourseItemResponse[]
}


export interface AdminCourseLevelResponse {
  id: number;
  name: string;
  isSelected: boolean
}


export interface ChallengeInfo {
  startedAt?: string
  | null;
  endedAt?: string
  | null;
  applyStartedAt?: string
  | null;
  applyEndedAt?: string
  | null;
  capacity: number;
  minCapacity: number;
  startedAtUTC?: string
  | null;
  endedAtUTC?: string
  | null;
  applyStartedAtUTC?: string
  | null;
  applyEndedAtUTC?: string
  | null
}


export interface CourseManagerInfo {
  id: number;
  courseId: number;
  manager: string;
  createdAt?: string
  | null;
  createdAtUTC: string
}


export interface GetAdminCourseDetailResponse {
  id: number;
  title: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  type: ("ON" | "OFF" | "CHALLENGE");
  slug?: string
  | null;
  enSlug?: string
  | null;
  price?: number
  | null;
  publishedAt?: string
  | null;
  lastUpdatedAt: string;
  keywords?: string
  | null;
  exposure: boolean;
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  contractStatus: ("DRAFT" | "NOT_SIGNED" | "CANCELED" | "SIGNED" | "TERMINATED" | "NO_REQUIRED");
  revenueUserId: number;
  revenueUsername: string;
  contractAgreedAtList?: string[]
  | null;
  levels: AdminCourseLevelResponse[];
  categories: GetAdminDetailCourseCategoryResponse[];
  skillTags: SkillTagResponse[];
  commonTags: CommonTagResponse[];
  challengeInfo: ChallengeInfo;
  courseManagerInfo?: CourseManagerInfo;
  instructors: InstructorResponse[];
  contractAgreedAtUTCList?: string[]
  | null
}


export interface GetAdminDetailCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parentTitle: string;
  parentSlug: string
}


export interface GetTranslatedCourseDetailResponse {
  requestLanguage: ("KO" | "EN" | "JA" | "VI");
  responseLanguage: ("KO" | "EN" | "JA" | "VI");
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  title: string;
  level: string;
  levelCode: string;
  description: string;
  shownCategory: string[];
  abilities: string[];
  targets: string[];
  based: string[];
  mainInstructors: MainInstructorResponse[];
  publishedAt?: string
  | null;
  lastUpdatedAt: string;
  curriculum: Section[];
  lastUpdatedAtUTC: string;
  publishedAtUTC?: string
  | null
}


export interface Section {
  id: number;
  title: string;
  units: Unit[]
}


export interface CourseSummaryDto {
  id: number;
  title: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  slug: string;
  originalLanguage: ("KO" | "EN" | "JA" | "VI");
  vodOriginalLanguage: ("KO" | "EN" | "JA" | "VI" | "CN" | "TW" | "HI" | "FR" | "CA" | "ES" | "MX" | "PT");
  thumbnailUrl: string;
  type: ("ON" | "OFF" | "CHALLENGE");
  instructor: Instructor
}


export interface CourseSummaryResponse {
  items: CourseSummaryDto[]
}


export interface Instructor {
  userId: number;
  name: string
}


export interface CourseStudentCountDto {
  id: number;
  studentCount: number
}


export interface GetCourseStudentResponse {
  items: CourseStudentCountDto[]
}


export interface CourseTranslationListResponse {
  items: CourseTranslationResponse[]
}


export interface CourseTranslationResponse {
  courseId: number;
  title: string;
  description: string;
  language: ("KO" | "EN" | "JA" | "VI")
}


export interface MultipleCourseTranslationListResponse {
  items: MultipleCourseTranslationResponse[]
}


export interface MultipleCourseTranslationResponse {
  courseId: number;
  title: string;
  description: string;
  language: ("KO" | "EN" | "JA" | "VI");
  htmlBody: string;
  abilities: string[]
}


export interface FindAnswerableCourseItem {
  id: number;
  canAnswer: boolean
}


export interface FindAnswerableCourseSurveyResponse {
  items: FindAnswerableCourseItem[]
}


export interface FindCourseSurveyAnswerResponse {
  id: number;
  createdAt: string;
  userId: number;
  userName: string;
  questionId?: number
  | null;
  content?: string
  | null;
  answeredAt?: string
  | null
}


export interface CourseProgressRateDto {
  courseId: number;
  progressRateHistogram: ProgressRateHistogramItem[]
}


export interface GetCourseProgressRateResponse {
  items: CourseProgressRateDto[]
}


export interface ProgressRateHistogramItem {
  percent: number;
  count: number
}


export interface CourseCrossStudentItem {
  instructorId: number;
  title: string;
  students: number
}


export interface GetCourseCrossStudentResponse {
  items: CourseCrossStudentItem[]
}


export interface CourseCompleteRateItem {
  id: number;
  title: string;
  percent: number
}


export interface GetCourseCompleteRateResponse {
  items: CourseCompleteRateItem[]
}


export interface CourseSkillAggregateResult {
  count: number;
  completedAt?: string
  | null;
  certificatedAt?: string
  | null;
  startedAt: string;
  createdAt?: string
  | null;
  isCompleted: boolean
}


export interface FindCourseContractHistoryResponse {
  ids: number[]
}


export interface CourseGiftByAdminItem {
  id: number;
  orderId: number;
  status: ("READY_TO_RECEIVE" | "RECEIVED" | "EXPIRED" | "CANCELED");
  message?: string
  | null;
  code: string;
  createdAt: string;
  canceledAt?: string
  | null;
  approvedAt?: string
  | null;
  senderUser: SenderUserInfo;
  receiverUser: ReceiverUserInfo;
  createdAtUTC: string;
  canceledAtUTC?: string
  | null;
  approvedAtUTC?: string
  | null
}


export interface CourseGiftByAdminResponse {
  items: CourseGiftByAdminItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPage: number
}


export interface ReceiverUserInfo {
  id?: number
  | null;
  name: string
}


export interface SenderUserInfo {
  id: number;
  name: string
}


export interface CourseDiscountResponse {
  discountTitle?: string
  | null;
  coursePrice: CoursePriceResponse;
  usdCoursePrice: CoursePriceResponse;
  discountStartedAt?: string
  | null;
  discountEndedAt?: string
  | null;
  discountStartedAtUTC?: string
  | null;
  discountEndedAtUTC?: string
  | null
}


export interface CoursePriceResponse {
  price: number;
  discountedPrice: number;
  regularPrice: number;
  sellingPrice: number;
  discountRate: number
}


export interface GetCourseCoverAiGenerationTemplateInputResponse {
  prompts: PromptItem[];
  referenceImages: string[]
}


export interface CourseCoverResponse {
  vodId?: string
  | null
}


export interface GetCourseContentAiGenerationInputsResponse {
  course: CourseResponse;
  representativeInstructor: RepresentativeInstructorResponse;
  cover: CourseCoverResponse;
  based: string[];
  abilities: string[];
  targets: string[];
  description?: string
  | null
}


export interface RepresentativeInstructorResponse {
  name: string;
  introduction?: string
  | null
}


export interface GetGroupUserCertificateDetailResponse {
  userId: number;
  courseId: number;
  voucherId: number;
  userRealName?: string
  | null;
  groupUserName?: string
  | null;
  courseTitle: string;
  courseRuntime: number;
  instructorName: string;
  startedAtUTC: string;
  certificatedAtUTC: string
}


export interface CertificateSummaryDto {
  voucherId: number;
  courseId: number;
  startedAt?: string
  | null;
  completedAt?: string
  | null;
  createdAt: string;
  certificatedAt?: string
  | null;
  title: string;
  startedAtUTC?: string
  | null;
  completedAtUTC?: string
  | null;
  createdAtUTC: string;
  certificatedAtUTC?: string
  | null
}


export interface GetCertificateSummaryByUserResponse {
  items: CertificateSummaryDto[]
}


export interface FindCoteVoucherResponse {
  id?: number
  | null
}


export interface ChallengeCategory {
  isMainCategory: boolean;
  name: string
}


export interface OriginalCourse {
  id: number;
  name: string;
  slug: string
}


export interface SearchChallengeResponse {
  items: SearchedChallenge[];
  totalCount: number
}


export interface SearchedChallenge {
  id: number;
  title: string;
  slug: string;
  status: ("DRAFT" | "PRIVATE" | "SUBMIT" | "PUBLISH" | "PAUSE" | "PUBLISH_READY");
  price?: number
  | null;
  publishedAt?: string
  | null;
  contractedAt?: string
  | null;
  instructor: InstructorInfo;
  categories: ChallengeCategory[];
  originalCourse?: OriginalCourse;
  isOnDiscount: boolean;
  publishedAtUTC?: string
  | null;
  contractedAtUTC?: string
  | null
}


export interface AdminFeaturedChallengeResponse {
  items: FeaturedChallenge[]
}


export interface CartDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  type: string;
  status?: string
  | null;
  quantity: number;
  title?: string
  | null;
  price?: number
  | null;
  payPrice?: number
  | null;
  deletedAt?: string
  | null;
  paidAt?: string
  | null;
  regPrice?: number
  | null;
  revenue?: number
  | null;
  byInstAt?: string
  | null;
  courseDc: boolean;
  courseDcTitle?: string
  | null;
  userId: number;
  courseId?: number
  | null;
  orderId?: number
  | null;
  instUserId?: number
  | null;
  course?: object;
  legacy?: object;
  couponUserId?: number
  | null;
  revenueInfo?: object;
  couponId?: number
  | null;
  discountId?: number
  | null;
  userDcId?: number
  | null;
  createdAtUTC: string;
  updatedAtUTC: string;
  deletedAtUTC?: string
  | null;
  paidAtUTC?: string
  | null;
  byInstAtUTC?: string
  | null
}


export interface FindCartResponse {
  items: CartDto[]
}


/** RoadmapItemType */
export const enum RoadmapItemType {
  'COURSE' = 'COURSE',
  'BOOK' = 'BOOK',
  'LINK' = 'LINK'
};


/** MissionAttachmentRequestType */
export const enum MissionAttachmentRequestType {
  'LINK' = 'LINK',
  'IMAGE' = 'IMAGE',
  'FILE' = 'FILE'
};


/** BankCode */
export const enum BankCode {
  'NH' = 'NH',
  'KB' = 'KB',
  'WOORI' = 'WOORI',
  'SHINHAN' = 'SHINHAN',
  'IBK' = 'IBK',
  'HANA' = 'HANA',
  'GYEONGNAM' = 'GYEONGNAM',
  'DAEGU' = 'DAEGU',
  'BUSAN' = 'BUSAN',
  'SUHYUP' = 'SUHYUP',
  'POST' = 'POST',
  'KDB' = 'KDB',
  'SC' = 'SC',
  'CITI' = 'CITI',
  'DGB' = 'DGB',
  'GWANGJU' = 'GWANGJU',
  'JEJU' = 'JEJU',
  'JEONBUK' = 'JEONBUK',
  'SAE_MAUL' = 'SAE_MAUL',
  'SHINHYEOP' = 'SHINHYEOP',
  'K_BANK' = 'K_BANK',
  'KAKAO_BANK' = 'KAKAO_BANK'
};


export const enum Type {
  'MAIN' = 'MAIN',
  'SUB' = 'SUB'
};


/** SurveyQuestionType */
export const enum SurveyQuestionType {
  'SUBJECTIVE' = 'SUBJECTIVE',
  'OBJECTIVE' = 'OBJECTIVE',
  'MULTIPLE_OBJECTIVE' = 'MULTIPLE_OBJECTIVE',
  'FILE' = 'FILE'
};


export const enum DiscountType {
  'COURSE' = 'COURSE',
  'USER' = 'USER',
  'PLATFORM' = 'PLATFORM',
  'NONE' = 'NONE',
  'COUPON' = 'COUPON'
};


/** DomesticPgType */
export const enum DomesticPgType {
  'NAVERPAY' = 'NAVERPAY',
  'TOSS' = 'TOSS',
  'TOSS_PAY' = 'TOSS_PAY'
};


/** OrderPaymentMethodType */
export const enum OrderPaymentMethodType {
  'CARD' = 'CARD',
  'NAVERPAY' = 'NAVERPAY',
  'NAVERPAY_MONEY' = 'NAVERPAY_MONEY',
  'KAKAOPAY' = 'KAKAOPAY',
  'PAYCO' = 'PAYCO',
  'TOSSPAY' = 'TOSSPAY',
  'TOSS_PAY_MONEY' = 'TOSS_PAY_MONEY',
  'APPLEPAY' = 'APPLEPAY',
  'VIRTUAL_ACCOUNT' = 'VIRTUAL_ACCOUNT',
  'LIFE_EDUCATION' = 'LIFE_EDUCATION',
  'OVERSEAS' = 'OVERSEAS',
  'INFPAY' = 'INFPAY',
  'BANK_TRANSFER' = 'BANK_TRANSFER',
  'LINKPAY' = 'LINKPAY',
  'UNKNOWN' = 'UNKNOWN',
  'NONE' = 'NONE'
};






/** GlobalPgType */
export const enum GlobalPgType {
  'PORTONE' = 'PORTONE',
  'TOSS' = 'TOSS'
};


/** GlobalPayMethod */
export const enum GlobalPayMethod {
  'NONE' = 'NONE',
  'PAYPAL' = 'PAYPAL'
};


/** CurrencyCode */
export const enum CurrencyCode {
  'KRW' = 'KRW',
  'USD' = 'USD',
  'VND' = 'VND',
  'JPY' = 'JPY'
};


export const enum Status {
  'READY' = 'READY',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'WAITING_FOR_DEPOSIT' = 'WAITING_FOR_DEPOSIT',
  'DONE' = 'DONE',
  'CANCELED' = 'CANCELED',
  'PARTIAL_CANCELED' = 'PARTIAL_CANCELED',
  'ABORTED' = 'ABORTED',
  'EXPIRED' = 'EXPIRED'
};


/** LiveSessionLectureRole */
export const enum LiveSessionLectureRole {
  'ADMIN' = 'ADMIN',
  'INSTRUCTOR' = 'INSTRUCTOR',
  'STUDENT' = 'STUDENT',
  'STUDENT_VIEWER' = 'STUDENT_VIEWER',
  'RECORDER' = 'RECORDER'
};


/** CourseGiftReceiveType */
export const enum CourseGiftReceiveType {
  'PHONE' = 'PHONE',
  'LINK' = 'LINK'
};




/** CourseContractHistoryType */
export const enum CourseContractHistoryType {
  'PLATFORM' = 'PLATFORM',
  'INFLUENCER' = 'INFLUENCER',
  'OFFLINE' = 'OFFLINE',
  'E' = 'E',
  'EXCLUSIVE' = 'EXCLUSIVE',
  'NONEXCLUSIVE' = 'NONEXCLUSIVE'
};


/** EarlyBirdSaleTerm */
export const enum EarlyBirdSaleTerm {
  'AGREE' = 'AGREE',
  'DISAGREE' = 'DISAGREE',
  'DELEGATE' = 'DELEGATE'
};


export const enum TargetType {
  'ALL' = 'ALL',
  'SELECTED' = 'SELECTED',
  'CATEGORY' = 'CATEGORY',
  'SKILL' = 'SKILL',
  'ROADMAP' = 'ROADMAP',
  'COMMON_TAG' = 'COMMON_TAG'
};


export const enum StatusCode {
  'OK' = 'OK',
  'CREATED' = 'CREATED',
  'BAD_REQUEST' = 'BAD_REQUEST',
  'NOT_FOUND' = 'NOT_FOUND',
  'INTERNAL_SERVER_ERROR' = 'INTERNAL_SERVER_ERROR',
  'FORBIDDEN' = 'FORBIDDEN',
  'CONFLICT' = 'CONFLICT',
  'UNAUTHORIZED' = 'UNAUTHORIZED',
  'PAYLOAD_TOO_LARGE' = 'PAYLOAD_TOO_LARGE',
  'TOO_MANY_REQUESTS' = 'TOO_MANY_REQUESTS'
};






export const enum CancelType {
  'B2B' = 'B2B',
  'B2C' = 'B2C'
};




export const enum DiscountStrategy {
  'PERCENT' = 'PERCENT',
  'PRICE' = 'PRICE'
};




/** CourseStatus */
export const enum CourseStatus {
  'DRAFT' = 'DRAFT',
  'PRIVATE' = 'PRIVATE',
  'SUBMIT' = 'SUBMIT',
  'PUBLISH' = 'PUBLISH',
  'PAUSE' = 'PAUSE',
  'PUBLISH_READY' = 'PUBLISH_READY'
};




export const enum PaymentMethodType {
  'CARD' = 'CARD',
  'NAVERPAY' = 'NAVERPAY',
  'NAVERPAY_MONEY' = 'NAVERPAY_MONEY',
  'KAKAOPAY' = 'KAKAOPAY',
  'TOSSPAY' = 'TOSSPAY',
  'TOSS_PAY_MONEY' = 'TOSS_PAY_MONEY',
  'APPLEPAY' = 'APPLEPAY',
  'VIRTUAL_ACCOUNT' = 'VIRTUAL_ACCOUNT',
  'LIFE_EDUCATION' = 'LIFE_EDUCATION',
  'OVERSEAS' = 'OVERSEAS',
  'INFPAY' = 'INFPAY',
  'BANK_TRANSFER' = 'BANK_TRANSFER',
  'PAYCO' = 'PAYCO',
  'UNKNOWN' = 'UNKNOWN',
  'NONE' = 'NONE',
  'LINKPAY' = 'LINKPAY',
  'LINKPAY_NAVERPAY' = 'LINKPAY_NAVERPAY',
  'LINKPAY_KAKAOPAY' = 'LINKPAY_KAKAOPAY',
  'LINKPAY_TOSSPAY' = 'LINKPAY_TOSSPAY',
  'LINKPAY_PAYCO' = 'LINKPAY_PAYCO',
  'LINKPAY_APPLEPAY' = 'LINKPAY_APPLEPAY',
  'LINKPAY_CARD' = 'LINKPAY_CARD',
  'LINKPAY_BANK_TRANSFER' = 'LINKPAY_BANK_TRANSFER',
  'FPX' = 'FPX',
  'SOFORT' = 'SOFORT',
  'PAYNOW' = 'PAYNOW',
  'GRABPAYPH' = 'GRABPAYPH',
  'GRABPAYMY' = 'GRABPAYMY',
  'BOOST' = 'BOOST',
  'TOUCHNGO' = 'TOUCHNGO',
  'KONBINI' = 'KONBINI',
  'PAYSHOP' = 'PAYSHOP',
  'BANCONTACT' = 'BANCONTACT',
  'EPS' = 'EPS',
  'MULTIBANCO' = 'MULTIBANCO',
  'PRZELEWY24' = 'PRZELEWY24',
  'BLIK' = 'BLIK',
  'IDEAL' = 'IDEAL',
  'PLATFORM' = 'PLATFORM',
  'POLI' = 'POLI',
  'INSTANT_BANK_TRANSFER' = 'INSTANT_BANK_TRANSFER',
  'UPI' = 'UPI'
};


export const enum PaymentChannel {
  'TOSS' = 'TOSS',
  'PAYMENTWALL' = 'PAYMENTWALL',
  'TAZAPAY' = 'TAZAPAY',
  'PAYPAL' = 'PAYPAL',
  'PAYLETTER' = 'PAYLETTER',
  'IAMPORT' = 'IAMPORT',
  'NAVERPAY' = 'NAVERPAY',
  'NONE' = 'NONE',
  'TOSS_PAY' = 'TOSS_PAY'
};




export const enum RefundStatus {
  'IDLE' = 'IDLE',
  'PENDING' = 'PENDING',
  'COMPLETE' = 'COMPLETE',
  'REJECT' = 'REJECT'
};






/** RoadmapStatus */
export const enum RoadmapStatus {
  'DRAFT' = 'DRAFT',
  'SUBMIT' = 'SUBMIT',
  'PUBLISH' = 'PUBLISH',
  'PAUSE' = 'PAUSE',
  'PRIVATE' = 'PRIVATE'
};




/** RoadmapHistoryType */
export const enum RoadmapHistoryType {
  'RESTORE' = 'RESTORE',
  'PUBLISH' = 'PUBLISH',
  'DRAFT' = 'DRAFT'
};


/** Language */
export const enum Language {
  'KO' = 'KO',
  'EN' = 'EN',
  'JA' = 'JA',
  'VI' = 'VI'
};




export const enum VodOriginalLanguage {
  'KO' = 'KO',
  'EN' = 'EN',
  'JA' = 'JA',
  'VI' = 'VI',
  'CN' = 'CN',
  'TW' = 'TW',
  'HI' = 'HI',
  'FR' = 'FR',
  'CA' = 'CA',
  'ES' = 'ES',
  'MX' = 'MX',
  'PT' = 'PT'
};










/** CourseSubType */
export const enum CourseSubType {
  'ONLINE' = 'ONLINE',
  'CLASS' = 'CLASS',
  'CONFERENCE' = 'CONFERENCE',
  'CHALLENGE' = 'CHALLENGE'
};




/** SubmissionStatusResponse */
export const enum SubmissionStatusResponse {
  'NONE' = 'NONE',
  'DRAFT' = 'DRAFT',
  'REJECTED' = 'REJECTED',
  'SUBMITTED' = 'SUBMITTED',
  'ACCEPTED' = 'ACCEPTED'
};




/** LiveSessionAttendanceStatus */
export const enum LiveSessionAttendanceStatus {
  'NONE' = 'NONE',
  'ATTENDED' = 'ATTENDED',
  'ABSENT' = 'ABSENT'
};


export const enum RecordingOption {
  'PROVIDED' = 'PROVIDED',
  'NOT_PROVIDED' = 'NOT_PROVIDED'
};










/** CourseContentType */
export const enum CourseContentType {
  'EDITOR' = 'EDITOR',
  'BUILDER' = 'BUILDER'
};


/** CoursePaymentInfoType */
export const enum CoursePaymentInfoType {
  'ENROLLED' = 'ENROLLED',
  'PURCHASE_UNAVAILABLE' = 'PURCHASE_UNAVAILABLE',
  'B2B_SUBSCRIPTION' = 'B2B_SUBSCRIPTION',
  'B2B_ENROLMENT_PENDING' = 'B2B_ENROLMENT_PENDING',
  'B2B_PURCHASE' = 'B2B_PURCHASE',
  'B2B_PURCHASE_RESTRICTED' = 'B2B_PURCHASE_RESTRICTED',
  'FREE' = 'FREE',
  'DISCOUNTED_PURCHASE' = 'DISCOUNTED_PURCHASE',
  'REGULAR_PRICE_PURCHASE' = 'REGULAR_PRICE_PURCHASE'
};












export const enum CourseType {
  'ON' = 'ON',
  'OFF' = 'OFF',
  'CHALLENGE' = 'CHALLENGE'
};


export const enum ChallengeStatus {
  'BEFORE_APPLY' = 'BEFORE_APPLY',
  'APPLYING' = 'APPLYING',
  'AFTER_APPLY' = 'AFTER_APPLY',
  'PROCESSING' = 'PROCESSING',
  'PARTICIPATING' = 'PARTICIPATING',
  'COMPLETED' = 'COMPLETED'
};






export const enum Tag {
  'IS_ACTIVE_IN_QUESTION' = 'IS_ACTIVE_IN_QUESTION',
  'IS_B2B_SUBSCRIPTION' = 'IS_B2B_SUBSCRIPTION',
  'HAS_MISSION' = 'HAS_MISSION',
  'IS_CHALLENGE_APPLYING' = 'IS_CHALLENGE_APPLYING',
  'IS_CHALLENGE_BEFORE_APPLY' = 'IS_CHALLENGE_BEFORE_APPLY',
  'IS_CHALLENGE_AFTER_APPLY' = 'IS_CHALLENGE_AFTER_APPLY',
  'IS_CHALLENGE_PROCESSING' = 'IS_CHALLENGE_PROCESSING',
  'IS_CHALLENGE_COMPLETED' = 'IS_CHALLENGE_COMPLETED',
  'IS_CHALLENGE_PARTICIPATING' = 'IS_CHALLENGE_PARTICIPATING'
};






export const enum SubmissionStatus {
  'DRAFT' = 'DRAFT',
  'REJECTED' = 'REJECTED',
  'SUBMITTED' = 'SUBMITTED',
  'ACCEPTED' = 'ACCEPTED'
};








export const enum ProductType {
  'ONLINE_COURSE' = 'ONLINE_COURSE',
  'OFFLINE_COURSE' = 'OFFLINE_COURSE',
  'MENTORING' = 'MENTORING'
};


/** UnitContentSummaryType */
export const enum UnitContentSummaryType {
  'VOD_SUBTITLE' = 'VOD_SUBTITLE',
  'UNIT_BODY' = 'UNIT_BODY'
};


/** QuizQuestionReactionType */
export const enum QuizQuestionReactionType {
  'LIKE' = 'LIKE',
  'DISLIKE' = 'DISLIKE'
};














/** RoadmapContentTemplateAuthorType */
export const enum RoadmapContentTemplateAuthorType {
  'INFLAB' = 'INFLAB',
  'USER' = 'USER'
};


export const enum Rank {
  'MASTER' = 'MASTER',
  'SCHOLAR' = 'SCHOLAR',
  'SKILL_BUILDER' = 'SKILL_BUILDER',
  'LEARNER' = 'LEARNER',
  'STARTER' = 'STARTER'
};


export const enum MaxStudyingTimeDayOfWeek {
  'MONDAY' = 'MONDAY',
  'TUESDAY' = 'TUESDAY',
  'WEDNESDAY' = 'WEDNESDAY',
  'THURSDAY' = 'THURSDAY',
  'FRIDAY' = 'FRIDAY',
  'SATURDAY' = 'SATURDAY',
  'SUNDAY' = 'SUNDAY'
};


export const enum MaxStudyingTimeTimeOfDay {
  'EARLY_MORNING' = 'EARLY_MORNING',
  'MORNING' = 'MORNING',
  'AFTERNOON' = 'AFTERNOON',
  'EVENING' = 'EVENING',
  'NIGHT' = 'NIGHT',
  'DAWN' = 'DAWN'
};


export const enum QuizUserStatus {
  'IN_PROGRESS' = 'IN_PROGRESS',
  'RETRYING' = 'RETRYING',
  'COMPLETED' = 'COMPLETED'
};


export const enum QuizQuestionUserStatus {
  'PASS' = 'PASS',
  'FAIL' = 'FAIL',
  'NOT_ATTEMPTED' = 'NOT_ATTEMPTED'
};




/** QuizUserStatusResponse */
export const enum QuizUserStatusResponse {
  'NOT_STARTED' = 'NOT_STARTED',
  'NO_PERMISSION' = 'NO_PERMISSION',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED'
};






/** MarketingPartnerType */
export const enum MarketingPartnerType {
  'BUSINESS' = 'BUSINESS',
  'PERSONAL' = 'PERSONAL'
};


/** PromotionCardContentType */
export const enum PromotionCardContentType {
  'COURSE' = 'COURSE',
  'URL' = 'URL'
};








export const enum OrderMode {
  'NORMAL' = 'NORMAL',
  'B2B_CODE' = 'B2B_CODE',
  'B2C_CODE' = 'B2C_CODE',
  'CODE' = 'CODE',
  'MENTOR' = 'MENTOR',
  'MENTORING' = 'MENTORING',
  'COURSE_GIFT' = 'COURSE_GIFT',
  'CLIP' = 'CLIP'
};




















/** LiveSessionType */
export const enum LiveSessionType {
  'STANDARD' = 'STANDARD',
  'LARGE_SCALE' = 'LARGE_SCALE'
};














export const enum ContractStatus {
  'DRAFT' = 'DRAFT',
  'NOT_SIGNED' = 'NOT_SIGNED',
  'CANCELED' = 'CANCELED',
  'SIGNED' = 'SIGNED',
  'TERMINATED' = 'TERMINATED',
  'NO_REQUIRED' = 'NO_REQUIRED'
};












/** MissionAttachmentType */
export const enum MissionAttachmentType {
  'NONE' = 'NONE',
  'LINK' = 'LINK',
  'IMAGE_FILE' = 'IMAGE_FILE',
  'ATTACHMENT_FILE' = 'ATTACHMENT_FILE'
};




































export const enum LocationType {
  'ONLINE' = 'ONLINE',
  'OFFLINE' = 'OFFLINE'
};
















/** CourseGiftStatus */
export const enum CourseGiftStatus {
  'READY_TO_RECEIVE' = 'READY_TO_RECEIVE',
  'RECEIVED' = 'RECEIVED',
  'EXPIRED' = 'EXPIRED',
  'CANCELED' = 'CANCELED'
};




export const enum PayMethod {
  'CARD' = 'CARD',
  'NAVERPAY' = 'NAVERPAY',
  'NAVERPAY_MONEY' = 'NAVERPAY_MONEY',
  'KAKAOPAY' = 'KAKAOPAY',
  'TOSSPAY' = 'TOSSPAY',
  'TOSS_PAY_MONEY' = 'TOSS_PAY_MONEY',
  'SAMSUNGPAY' = 'SAMSUNGPAY',
  'APPLEPAY' = 'APPLEPAY',
  'PAYCO' = 'PAYCO',
  'VIRTUAL_ACCOUNT' = 'VIRTUAL_ACCOUNT',
  'BANK_TRANSFER' = 'BANK_TRANSFER',
  'LIFE_EDUCATION' = 'LIFE_EDUCATION',
  'OVERSEAS' = 'OVERSEAS',
  'INFPAY' = 'INFPAY',
  'VBANK' = 'VBANK',
  'CARD_LEGACY' = 'CARD_LEGACY',
  'NAVERPAY_LEGACY' = 'NAVERPAY_LEGACY',
  'POINT' = 'POINT',
  'PHONE' = 'PHONE',
  'EMPTY' = 'EMPTY',
  'NONE' = 'NONE',
  'FPX' = 'FPX',
  'SOFORT' = 'SOFORT',
  'PAYNOW' = 'PAYNOW',
  'GRABPAYPH' = 'GRABPAYPH',
  'GRABPAYMY' = 'GRABPAYMY',
  'BOOST' = 'BOOST',
  'TOUCHNGO' = 'TOUCHNGO',
  'KONBINI' = 'KONBINI',
  'PAYSHOP' = 'PAYSHOP',
  'BANCONTACT' = 'BANCONTACT',
  'EPS' = 'EPS',
  'MULTIBANCO' = 'MULTIBANCO',
  'PRZELEWY24' = 'PRZELEWY24',
  'BLIK' = 'BLIK',
  'IDEAL' = 'IDEAL',
  'PLATFORM' = 'PLATFORM',
  'POLI' = 'POLI',
  'INSTANT_BANK_TRANSFER' = 'INSTANT_BANK_TRANSFER',
  'UPI' = 'UPI'
};




export const enum Pg {
  'KAKAOPAY' = 'KAKAOPAY',
  'NAVERPAY' = 'NAVERPAY',
  'TOSS_WIDGET' = 'TOSS_WIDGET',
  'TOSS' = 'TOSS',
  'TOSS_V2' = 'TOSS_V2',
  'TOSS_GLOBAL' = 'TOSS_GLOBAL',
  'TOSS_PAY_LEGACY' = 'TOSS_PAY_LEGACY',
  'TOSS_PAY' = 'TOSS_PAY',
  'IMP_KAKAOPAY' = 'IMP_KAKAOPAY',
  'IMP_NAVERPAY' = 'IMP_NAVERPAY',
  'IMP_NICE' = 'IMP_NICE',
  'IMP_JTNET' = 'IMP_JTNET',
  'PORTONE' = 'PORTONE'
};
































export const enum RequiredImageType {
  'NONE' = 'NONE',
  'PERSON' = 'PERSON'
};








export const enum TermType {
  'NEW_CONTRACT' = 'NEW_CONTRACT',
  'MODIFICATION_CONTRACT' = 'MODIFICATION_CONTRACT'
};








/** CourseContentTemplateAuthorType */
export const enum CourseContentTemplateAuthorType {
  'INFLAB' = 'INFLAB',
  'INSTRUCTOR' = 'INSTRUCTOR'
};




export const enum RequiredInfoType {
  'NONE' = 'NONE',
  'INSTRUCTOR_PROFILE' = 'INSTRUCTOR_PROFILE'
};


export const enum TemplateKey {
  'PROBLEM' = 'PROBLEM',
  'RESULT' = 'RESULT',
  'STORY' = 'STORY'
};




















/** ChallengeNotificationSubscriptionType */
export const enum ChallengeNotificationSubscriptionType {
  'CHALLENGE_APPLY_STARTED' = 'CHALLENGE_APPLY_STARTED',
  'NEW_CHALLENGE_OPENED' = 'NEW_CHALLENGE_OPENED'
};


















/** PromotionCardActiveStatus */
export const enum PromotionCardActiveStatus {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE'
};




export const enum AttachmentType {
  'LINK' = 'LINK',
  'IMAGE' = 'IMAGE',
  'FILE' = 'FILE',
  'NONE' = 'NONE'
};






export const enum PaymentMethod {
  'CARD' = 'CARD',
  'NAVERPAY' = 'NAVERPAY',
  'NAVERPAY_MONEY' = 'NAVERPAY_MONEY',
  'KAKAOPAY' = 'KAKAOPAY',
  'TOSSPAY' = 'TOSSPAY',
  'TOSS_PAY_MONEY' = 'TOSS_PAY_MONEY',
  'SAMSUNGPAY' = 'SAMSUNGPAY',
  'APPLEPAY' = 'APPLEPAY',
  'PAYCO' = 'PAYCO',
  'VIRTUAL_ACCOUNT' = 'VIRTUAL_ACCOUNT',
  'BANK_TRANSFER' = 'BANK_TRANSFER',
  'LIFE_EDUCATION' = 'LIFE_EDUCATION',
  'OVERSEAS' = 'OVERSEAS',
  'INFPAY' = 'INFPAY',
  'VBANK' = 'VBANK',
  'CARD_LEGACY' = 'CARD_LEGACY',
  'NAVERPAY_LEGACY' = 'NAVERPAY_LEGACY',
  'POINT' = 'POINT',
  'PHONE' = 'PHONE',
  'EMPTY' = 'EMPTY',
  'NONE' = 'NONE',
  'FPX' = 'FPX',
  'SOFORT' = 'SOFORT',
  'PAYNOW' = 'PAYNOW',
  'GRABPAYPH' = 'GRABPAYPH',
  'GRABPAYMY' = 'GRABPAYMY',
  'BOOST' = 'BOOST',
  'TOUCHNGO' = 'TOUCHNGO',
  'KONBINI' = 'KONBINI',
  'PAYSHOP' = 'PAYSHOP',
  'BANCONTACT' = 'BANCONTACT',
  'EPS' = 'EPS',
  'MULTIBANCO' = 'MULTIBANCO',
  'PRZELEWY24' = 'PRZELEWY24',
  'BLIK' = 'BLIK',
  'IDEAL' = 'IDEAL',
  'PLATFORM' = 'PLATFORM',
  'POLI' = 'POLI',
  'INSTANT_BANK_TRANSFER' = 'INSTANT_BANK_TRANSFER',
  'UPI' = 'UPI'
};




/** MarketingPartnerStatus */
export const enum MarketingPartnerStatus {
  'PENDING' = 'PENDING',
  'APPROVED' = 'APPROVED'
};


































